var _rect, _path, _rect2, _path2, _rect3, _path3, _polygon, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReserveRide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.18,
    y: 111.82,
    width: 229.11,
    height: 134.02,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.81,
    y: 119.79,
    width: 214.87,
    height: 119.17,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264.01 119.79 380.55 238.95 407.97 238.95 407.97 227.49 300.54 119.79 264.01 119.79",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.69 119.79 466.68 194.06 466.68 156.92 427.26 119.79 394.69 119.79",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.87,257.39c-2.08-8.83-6.13-17.7-13.5-22.76s-18.58-4.9-24.14,2.18a15.79,15.79,0,0,0-15.2-8.24,16,16,0,0,0-13.27,11.21c-5.54-7-16.65-8.4-23.68-3-3.86-6.17-9.05-12.14-16-13.76s-15.57,3.3-15.51,10.63c-7.17-6.11-19.85-2.72-23.19,6.21a30.85,30.85,0,0,0-36.81,1.37c-9.84-9.25-23.37-15.34-36.51-13s-24.73,15-23.28,28.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.11,
    y: 255.92,
    width: 255.62,
    height: 26.63,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.63,
    y: 96.78,
    width: 163.76,
    height: 370.81,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.56,
    y: 150.74,
    width: 6.49,
    height: 30.7,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.01,
    y: 383.02,
    width: 6.27,
    height: 29.69,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.28,
    y: 110.28,
    width: 141.49,
    height: 340,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.65,110.28c1.41,0,110.11,158.08,110.11,156.11V220.52L109.84,110.28Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.51 110.28 190.76 212.29 190.76 188.34 133.86 110.28 119.51 110.28",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.53,
    y: 256.39,
    width: 6.98,
    height: 71.18,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.82,
    y: 253.94,
    width: 8,
    height: 70.77,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.29,43.73V57c0,14.68,11.61,26.59,25.94,26.59h0c14.33,0,25.94-11.91,25.94-26.59V43.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.27,43.73V57c0,14.68,11.62,26.59,25.94,26.59h0c14.33,0,26-11.91,26-26.59V43.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.6,43.73V57c0,14.68,11.62,26.59,26,26.59h0c14.32,0,25.94-11.91,25.94-26.59V43.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.94,43.73V57c0,14.68,11.61,26.59,25.94,26.59h0c14.32,0,25.94-11.91,25.94-26.59V43.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.27,43.73V57c0,14.68,11.61,26.59,25.94,26.59h0c14.32,0,25.94-11.91,25.94-26.59V43.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.6,43.73V57c0,14.68,11.61,26.59,25.94,26.59h0c14.32,0,25.94-11.91,25.94-26.59V43.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.93,43.73V57c0,14.68,11.61,26.59,25.94,26.59h0c14.33,0,25.94-11.91,25.94-26.59V43.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.26,43.73V57c0,14.68,11.61,26.59,25.94,26.59h0c14.33,0,25.94-11.91,25.94-26.59V43.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.59,43.73V57c0,14.68,11.61,26.59,25.94,26.59h0c14.33,0,25.94-11.91,25.94-26.59V43.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12.29 43.73 23.53 24.31 72.87 24.31 64.17 43.73 12.29 43.73",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.34 24.31 117.6 43.73 64.17 43.73 72.87 24.31 121.34 24.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.94,43.73c.16-1.27,3.94-19.42,3.94-19.42H121.34L117.6,43.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.27 43.73 219.07 24.31 173.88 24.31 169.94 43.73 222.27 43.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.6 43.73 268.2 24.31 219.07 24.31 222.27 43.73 274.6 43.73",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.55 24.31 326.93 43.73 274.6 43.73 268.2 24.31 317.55 24.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.26 43.73 368.05 24.31 317.55 24.31 326.93 43.73 379.26 43.73",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "431.59 43.73 415.41 24.31 368.05 24.31 379.26 43.73 431.59 43.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "483.47 43.73 465.28 24.31 415.41 24.31 431.59 43.73 483.47 43.73",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.3,
    y: 386.91,
    width: 33.51,
    height: 8.87,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.65,405.12a.46.46,0,0,1,0-.16c0-.12,0-.27,0-.46q0-.63,0-1.74c0-1.53,0-3.74-.06-6.51l.11.1-33.51.07c.07-.08-.18.17.16-.17h0v8.84l-.17-.17L409,405l7.05,0,1.9,0,.5,0H418l-1.87,0-7,0-24,.07H385v-.16c0-1.43,0-2.88,0-4.36v-4.48h0c.34-.34.1-.09.18-.17l33.51.07h.1v.1c0,2.8,0,5-.06,6.57,0,.73,0,1.31,0,1.72,0,.18,0,.32,0,.44S418.65,405.12,418.65,405.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.76,356.67a1.57,1.57,0,0,1,0-.2c0-.15,0-.34,0-.58,0-.52,0-1.26,0-2.2,0-1.93,0-4.71-.07-8.21l.13.13-42.32.08c.1-.09-.21.22.22-.21h0v11.19l-.21-.21,30.16.1,8.9.06,2.41,0,.63,0h.22l-.2,0H467l-2.36,0-8.85.06-30.31.09h-.21v-5.72c0-.93,0-1.87,0-2.82v-2.86h0c.44-.44.13-.12.22-.22l42.32.08h.13v.13c0,3.53-.05,6.34-.07,8.29,0,.93,0,1.65,0,2.17,0,.23,0,.41,0,.55A.93.93,0,0,1,467.76,356.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.5,345.48a1.12,1.12,0,0,1,0-.22c0-.16,0-.35,0-.59,0-.55,0-1.3,0-2.25,0-2-.05-4.73-.09-8.14l.16.16-25.43.06.22-.22h0v2.9c0,1,0,1.91,0,2.85v5.43l-.21-.21,18.19.1,5.3.06,1.43,0,.51,0-.46,0-1.39,0-5.25.05-18.33.1h-.2v-.2c0-1.74,0-3.56,0-5.43V334.3h0l.21-.22,25.43.07h.15v.15c0,3.45-.06,6.25-.08,8.24,0,.93,0,1.67,0,2.21A6.83,6.83,0,0,1,473.5,345.48Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M465.74,467.26c0,.14-98.31.26-219.55.26s-219.57-.12-219.57-.26S124.9,467,246.19,467,465.74,467.12,465.74,467.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.83,467.06,159.62,467A31.58,31.58,0,0,1,128,435.43l.07-363a31.58,31.58,0,0,1,31.65-31.53L304.94,41a31.59,31.59,0,0,1,31.61,31.55l-.07,363A31.59,31.59,0,0,1,304.83,467.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.85,51.79l-28.25-.13a7,7,0,0,0-6.89,7.14l0,5.13a7,7,0,0,1-6.89,7.14l-55.06-.26a7,7,0,0,1-6.83-7.2l0-5.12a7,7,0,0,0-6.83-7.21l-9.94,0-24.72-.12a22.25,22.25,0,0,0-22.34,22.14l-1.5,356.56a22.22,22.22,0,0,0,22.12,22.33l145.42.67a22.25,22.25,0,0,0,22.34-22.14L328,74.12A22.22,22.22,0,0,0,305.85,51.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.13,385.44c-.17,4.3-.33,8.34-.46,11.7h20.89L262,384.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.23,390.81l.19,6.33h82.17c.14-3.56.29-7.5.45-11.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.06 384.24 265.63 397.14 304.14 397.14 303.67 381.67 263.06 384.24",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "246.22 203.95 253.5 161.73 234.42 160.31 234.42 203.95 246.22 203.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.52 367.37 136.82 375.48 136.75 390.14 158.13 388.79 157.52 367.37",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.42 364.07 156.29 324.75 156.27 324.75 156.27 310.88 137.08 312.91 136.83 372.11 157.41 364.05 157.42 364.07",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.27 279.92 137.23 277.41 137.09 309.77 156.27 307.74 156.27 279.92",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.2 311.47 297.4 322.73 274.91 325.16 276.65 334.08 302.19 332.15 301.8 319.37 303.84 310.9 298.2 311.47",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.67 335.51 275.61 334.16 271.7 314.14 256.05 315.72 257.67 335.51",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.84 337.58 259.21 354.27 261.64 377.17 262.64 382.18 303.61 379.58 302.25 334.24 257.84 337.58",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.33,258.79l1.58,2.7-31.59,18.43v43.71l33.34-2.36,64.26-6.48-2.35-28.66-61.39-8,.4-3.1L252.31,283l-4-48.5-60.11,5.78-.2-2.07,60.14-5.78-2.08-25.31H188.26l-50.77,9.24-.25,57.95,19.23,2.53Zm-26.78,60.67s.24-36,0-37.39l25.78-13.71,3.34,49.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.1 311.68 272.74 314.04 274.51 323.11 295.45 320.85 296.1 311.68",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.43,377.71c-.08,1.9-.15,3.78-.22,5.63l17.38-1.1-.89-4.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.98 203.95 210.04 190.06 233.38 190.06 233.38 160.24 160.4 154.83 160.4 182.84 137.61 187.99 137.5 213.13 187.98 203.95 206.98 203.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.68,121l-.63-2.56,27.87-11L264.79,71a6.53,6.53,0,0,1-1,.08L233,70.92l.84,50.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.91,101.44l0-49.68-20.28-.1a7,7,0,0,0-6.89,7.14l0,5.13a7.26,7.26,0,0,1-3,5.88l18.14,36.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.15,103.58,190.8,51.26l-5.65,0-22-.11-9.39,46.78Zm-5-47,.75,42.61-29.29-4.29L166,56.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.21,103.73v.44c.05,4.09.13,11.43.19,19.29l38.38-1.57-.84-51-23.22-.11a7,7,0,0,1-6.83-7.2l0-5.12a7,7,0,0,0-6.83-7.21h-3.25l2.36,52.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.62,97.47l9.3-46.32a22.22,22.22,0,0,0-21.83,22.11L138,96.35l.09-.68Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.28 154.6 137.76 153.15 137.62 184.78 157.28 180.34 157.28 154.6",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.41 98.49 138 96.71 137.78 147.93 140.45 148.13 150.41 98.49",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.84 363.47 190.17 322.35 157.33 324.67 158.49 364.96 189.84 363.47",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.88,354l46.51,22.28c.56-14.56,1.05-28.17,1-29l1-.05.49-1c.66.33.66.33.31,10.26-.19,5.54-.47,12.91-.75,20.28h16.09l-2.38-22.35L255,315.83,194.24,322Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.89 285.74 309.37 280.31 253.62 286.11 255.96 314.68 304.1 309.82 309.89 285.74",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.38 193.19 212.56 193.19 210.18 203.95 233.38 203.95 233.38 193.19",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.28,196.82l-52.16-3.61L247,205.53l2.19,26.75,55-5.29ZM251,205.51l2.8-7.78,45.3,2.87,2.63,22.25-49.19,5.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.69 252.72 304.4 229.06 249.37 234.35 251.43 259.52 306.69 252.72",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.19 390.87 136.84 392.22 136.75 390.83 136.72 397.14 158.37 397.14 158.19 390.87",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.59,89.7l.31.79L328,74.12a22.22,22.22,0,0,0-22.12-22.33l-6.93,0L299,101Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.35,377.4l-47.47-22.75-1.68-32.59-2,.2-.33,42.21L158.52,366l0,.94v0h0l.62,21.76,83-5.25C242.2,381.46,242.27,379.42,242.35,377.4Zm-81.8-8.72,45.29-3.17,29.47,13.67-74.76,4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.1,144.42,316,132.9c-17-6.08-18.2-23.83-18.15-29.21l-11.12,4.4,16.74,33.59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.36 283 276.51 280.59 271.94 260.15 251.69 262.64 253.36 283",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.29 164.46 260.06 164.46 256.47 164.19 251.59 192.5 302.91 196.05 301.71 183.74 306.76 165.56 303.29 164.46",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.3,156.87l.55-13.52-17-34.1-26.34,10.42,9.06,37.2ZM282.83,113.4,298.4,143l-2.25,9.23-26.64-1-6.66-28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.03 319.91 307.83 346.45 326.56 345.39 326.62 346.43 307.86 347.49 308.81 379.26 326.52 378.14 326.65 380.22 308.88 381.34 309.35 397.14 326.61 397.14 326.98 308.56 309.33 310.34 307.03 319.91",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.18,104.63l-39.67-5.69-9.92,49.42,49.76,3.69C193.55,144.44,193.38,121.1,193.18,104.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.42 156.87 264.42 156.87 255.93 121.99 233.85 122.89 234.38 155.09 258.42 156.87",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.62,422.51l0,7.31c0,.23,0,.45,0,.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.37,152.12l39,2.89-.53-32.07-38.39,1.56C194.5,135.35,194.53,146.92,194.37,152.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "306.99 255.83 272.98 260.02 277.55 280.48 309.06 277.2 306.99 255.83",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.21,131.85l2.18-12.92,9.39.73.12-27.84-29,11.46C298.35,122.87,310.66,129.76,316.21,131.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.06 181.82 306.25 194.03 327.46 195.5 327.57 170.35 309.81 164.74 305.06 181.82",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.16,286.1l-5.57,23.17,17.4-1.76.1-24.29c-5.34-1.4-10-2.55-12.5-3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "303.42 157.26 327.59 164.9 327.65 151.15 303.91 145.01 303.42 157.26",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.28,277c2,.29,5.64,1.07,12.82,3l.23-53.11-17.74,1.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.39 226.49 327.34 224.76 327.45 198.63 306.55 197.19 309.39 226.49",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.22,132.51a96.32,96.32,0,0,0,9.5,2.42l0-13.18-7.64-.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.12,144.94l11.54,3,0-11.91c-3-.6-6.2-1.41-9.67-2.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.65,380.22l-.13-2.08-17.71,1.12-.95-31.77,18.76-1.06-.06-1-18.73,1.06-.8-26.54,2.3-9.57L327,308.56v-1.05l-17.4,1.76,5.57-23.17-.57-5.91c2.5.48,7.16,1.63,12.5,3V280c-7.18-1.89-10.87-2.67-12.82-3l-4.69-48.45,17.74-1.7v-2.1l-17.95,1.73-2.84-29.31,20.9,1.45V195.5L306.25,194l-1.19-12.21,4.75-17.08,17.76,5.61,0-5.45-24.17-7.64.49-12.25,23.74,6.14v-3.23l-11.54-3L318,133.55c3.47,1,6.69,1.86,9.67,2.46v-1.08a96.32,96.32,0,0,1-9.5-2.42l1.91-11.36,7.64.6v-2.09l-9.39-.73-2.18,12.92c-5.55-2.09-17.86-9-17.27-28.57l29-11.46V90.49l-.31-.79L299,101l0-49.27h-1l0,49.68-12.07,4.78L267.7,69.81A6.67,6.67,0,0,1,264.79,71l18.13,36.38-27.87,11,.63,2.56-21.84.89L233,70.92H232l.84,51-38.38,1.57c-.06-7.86-.14-15.2-.19-19.29v-.44h0l-2.36-52.46h-1l2.35,52.32-39.43-5.67,9.39-46.78h-2.68c-.18,0-.34,0-.51,0l-9.3,46.32-12.53-1.8-.09.68v.36l12.42,1.78-10,49.64-2.67-.2,0,5.22,19.52,1.45v25.74l-19.66,4.44V188l22.79-5.15v-28l73,5.41v29.82H210.05L207,204H188l-50.48,9.18v3.18l50.77-9.24h57.82l2.08,25.31L188,238.16l.2,2.07,60.11-5.78,4,48.5L191.58,275l-.4,3.1,61.39,8,2.35,28.66-64.26,6.48-33.34,2.36V279.92l31.59-18.43-1.58-2.7-30.86,18-19.23-2.53v3.15l19,2.51v27.82l-19.18,2v3.14l19.19-2v13.87h0l1.13,39.32v0l-20.58,8.06v3.37l20.7-8.11.61,21.42-21.38,1.35v.69l.09,1.39,21.35-1.35.18,6.27h1l-.19-6.33L242,385.57c-.16,4.07-.31,8-.45,11.57h2.08c.13-3.36.29-7.4.46-11.7L262,384.31l2.55,12.83h1.06l-2.57-12.9,40.62-2.57.47,15.47h5.21m-65.14-13.8c.07-1.85.14-3.73.22-5.63l16.27.05.89,4.48Zm18.43-1.16-1-5-2.43-22.89-1.37-16.7,44.41-3.34,1.36,45.35ZM272.74,314l23.36-2.36-.65,9.17-20.94,2.26Zm-1,.1,3.91,20-17.94,1.35-1.62-19.79Zm30.49,18-25.54,1.93-1.74-8.92,22.49-2.43.81-11.26,5.63-.57-2,8.47Zm-30.25-72,4.57,20.44L253.36,283l-1.67-20.36Zm5.61,20.33L273,260l34-4.19,2.07,21.37ZM301,193.66l-51.32-3.55,4.88-28.31,3.59.27h43.23l3.47,1.09-5.05,18.19Zm-3.09-90c-.05,5.38,1.12,23.13,18.15,29.21l-1.94,11.52-10.59-2.74-16.74-33.59Zm-14,5.56,17,34.1-.55,13.52H266.57l-9.06-37.2ZM255.93,122l8.49,34.88h-6l-24-1.78-.53-32.2Zm-23.12,1,.53,32.07-39-2.89c.16-5.2.13-16.77,0-27.62Zm-79.3-24,39.67,5.69c.2,16.47.37,39.81.17,47.42l-49.76-3.69Zm100,62.79L246.21,204H234.42V160.31Zm-40.94,31.46h20.82V204h-23.2ZM247,205.53l2.12-12.32,52.16,3.61L304.2,227l-55,5.29Zm57.4,23.53,2.29,23.66-55.26,6.8-2.07-25.17Zm-50.78,57.05,55.75-5.8.52,5.43-5.79,24.08L256,314.68Zm4.55,68.26,2.38,22.35H244.46c.28-7.37.56-14.74.75-20.28.35-9.93.35-9.93-.31-10.26l-.49,1-1,.05c0,.87-.45,14.48-1,29L195.88,354l-1.64-32L255,315.83Zm-68-32-.33,41.12L158.49,365l-1.16-40.29ZM158.55,367h0v0l0-.94,32.36-1.53.33-42.21,2-.2,1.68,32.59,47.47,22.75c-.08,2-.15,4.06-.23,6.07l-83,5.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.84 365.5 160.55 368.68 160.55 383.22 235.31 379.18 205.84 365.5",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "299.14 200.6 253.84 197.74 251.04 205.51 252.58 228.68 301.76 222.85 299.14 200.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5,204l-.91,218.56v8c.3,12,9.13,21.55,21.14,21.61l146.46.72a22.22,22.22,0,0,0,22.28-22.14l1-226.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "189.76 101.89 189.01 59.28 166.88 59.28 160.46 97.6 189.76 101.89",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "296.15 152.25 298.4 143.02 282.83 113.4 262.85 123.23 269.51 151.24 296.15 152.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.31,142.48A7,7,0,1,0,153.19,146h0l0,0c.27.46.61.78.95,1.26l4.09,5.42a1.28,1.28,0,0,0,2,0l4-5.33a14.58,14.58,0,0,0,1-1.35l0,0h0A7.06,7.06,0,0,0,166.31,142.48Zm-7.05,3.06a3.1,3.1,0,1,1,3.1-3.1A3.1,3.1,0,0,1,159.26,145.54Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,91.86a7,7,0,1,0-13.11,3.56h0l0,0c.27.45.61.78.95,1.26l4.09,5.42a1.29,1.29,0,0,0,2,0l4-5.33a15.19,15.19,0,0,0,1-1.36v0h0A6.93,6.93,0,0,0,306,91.86Zm-7,3.07a3.1,3.1,0,1,1,3.1-3.1A3.1,3.1,0,0,1,298.92,94.93Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.35 160.81 266.4 160.81 232.5 157.32 232.31 123.44 194.9 123.95 193.99 154.57 160.26 153.24 160.3 152.24 193.02 153.53 193.93 122.97 233.31 122.43 233.5 156.41 266.45 159.82 300.35 159.81 300.35 143.46 284.72 107.61 297.68 101 298.14 101.89 286.01 108.07 301.35 143.25 301.35 160.81",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.59,383.34H327a0,0,0,0,1,0,0v48.21a21.26,21.26,0,0,1-21.26,21.26H158.37A21.79,21.79,0,0,1,136.59,431V383.34A0,0,0,0,1,136.59,383.34Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.75,
    y: 323.84,
    width: 189.94,
    height: 58.73,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.35,418.76l.83-1.84a6.2,6.2,0,0,0,3.48,1.1c1.45,0,2-.48,2-1.13,0-2-6.12-.62-6.12-4.53,0-1.79,1.44-3.28,4.44-3.28a7.06,7.06,0,0,1,3.66.93l-.76,1.85A6,6,0,0,0,199,411c-1.44,0-2,.55-2,1.21,0,1.94,6.13.6,6.13,4.47,0,1.76-1.46,3.27-4.47,3.27A7.56,7.56,0,0,1,194.35,418.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,417.84v2h-8.16V409.26h8v2h-5.55v2.28h4.9v1.9h-4.9v2.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.89,409.26h2.44v8.55h5.29v2h-7.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.15,417.84v2H224V409.26h8v2h-5.55v2.28h4.9v1.9h-4.9v2.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.4,414.53a5.81,5.81,0,0,1,10.06-3.59l-1.57,1.45a3.39,3.39,0,0,0-2.65-1.24,3.38,3.38,0,0,0,0,6.75,3.33,3.33,0,0,0,2.65-1.25l1.57,1.45a5.8,5.8,0,0,1-10.06-3.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.18,411.24H243.8v-2H253v2h-3.37v8.56h-2.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.9,414.53A5.81,5.81,0,0,1,268,410.94l-1.57,1.45a3.39,3.39,0,0,0-2.65-1.24,3.38,3.38,0,0,0,0,6.75,3.33,3.33,0,0,0,2.65-1.25L268,418.1a5.8,5.8,0,0,1-10.06-3.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.33,417.54h-4.89l-.94,2.26H268l4.7-10.54h2.41l4.72,10.54h-2.56Zm-.77-1.85-1.67-4-1.67,4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.64,419.8l-2-2.94h-2.25v2.94h-2.44V409.26h4.57c2.81,0,4.58,1.46,4.58,3.82a3.44,3.44,0,0,1-2.17,3.33l2.36,3.39Zm-2.29-8.56h-2v3.68h2c1.49,0,2.25-.69,2.25-1.84S286.84,411.24,285.35,411.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.1,
    y: 350.96,
    width: 66.55,
    height: 9,
    transform: "translate(538.75 710.92) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 236.1,
    y: 350.96,
    width: 66.55,
    height: 9,
    transform: "translate(538.75 710.92) rotate(180)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M233.3,350.2a5.54,5.54,0,0,1,4.54-3.58l14.94-1.75,5.45-3.9a22.39,22.39,0,0,1,13-4.16h35.45a.64.64,0,0,1,.5.25.62.62,0,0,1-.26.93l-2.55,1.09a4.66,4.66,0,0,1,.25.5l1.45,3.35a6.55,6.55,0,0,1,.53,2.58,1.46,1.46,0,0,1,1.46,1.46v5.83l1.52.68a2,2,0,0,1,1.19,1.84v1.52a2.47,2.47,0,0,1-2,2.42l-8,1.6v-.72A7.73,7.73,0,0,0,293,352.4h0a7.73,7.73,0,0,0-7.74,7.74v.72h-32.2v-.72a7.74,7.74,0,0,0-7.74-7.74h0a7.73,7.73,0,0,0-7.74,7.74v.72h-4a1.94,1.94,0,0,1-1.94-1.93v-4.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.61,339.58l1.45,3.35a6.55,6.55,0,0,1,.53,2.58h-2l-2-5.7,1.71-.73A4.66,4.66,0,0,1,304.61,339.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.3,350.2a6.25,6.25,0,0,1,.45-.94h2.12L234,353.71,231.72,355v-.49Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M233.3,350.2a6.25,6.25,0,0,1,.45-.94h2.12L234,353.71,231.72,355v-.49Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.9,350.83h-1.1a3,3,0,0,1-1.75-.55L303.22,349a1.21,1.21,0,0,1-.51-1h0a1.19,1.19,0,0,1,1.19-1.19h4a.18.18,0,0,1,.18.17v3.65A.16.16,0,0,1,307.9,350.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M231.61,354.8l.64-.37h-.39a.23.23,0,0,1,0-.46h1.19l.4-.23h-1.36a.23.23,0,1,1,0-.46h1.8l.1-.23h-1.63a.24.24,0,0,1,0-.47h1.83l.1-.23h-1.7a.23.23,0,0,1-.24-.23.24.24,0,0,1,.24-.23h1.9l.1-.23h-1.74a.23.23,0,1,1,0-.46h1.94l.1-.23h-1.77a.23.23,0,0,1-.23-.23.23.23,0,0,1,.23-.23h2l.1-.23h-1.82a.24.24,0,0,1,0-.47h2l.14-.32h-1.77a.23.23,0,0,1-.23-.23.24.24,0,0,1,.23-.23h2.12a.21.21,0,0,1,.19.11.2.2,0,0,1,0,.21l-.63,1.48h0l-.3.69h0l-.3.69h0l-.3.7h0l-.29.69h0l-.09.2a.22.22,0,0,1-.1.11l-2.23,1.29a.27.27,0,0,1-.12,0,.24.24,0,0,1-.2-.11A.24.24,0,0,1,231.61,354.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.6,360.36a6.75,6.75,0,1,1-6.84-6.65A6.76,6.76,0,0,1,299.6,360.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.59,360.34v0a6.75,6.75,0,0,1-13.49.19h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.59,360.39a4.74,4.74,0,1,1-4.81-4.67A4.74,4.74,0,0,1,297.59,360.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.78,355.72a4.74,4.74,0,0,1,4.81,4.67l-9.47.13A4.73,4.73,0,0,1,292.78,355.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.74,360.41a2.89,2.89,0,1,1-2.93-2.84A2.89,2.89,0,0,1,295.74,360.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.06,360.36a6.75,6.75,0,1,1-6.84-6.65A6.75,6.75,0,0,1,252.06,360.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.06,360.34v0a6.75,6.75,0,0,1-13.49.19h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.05,360.39a4.74,4.74,0,1,1-4.8-4.67A4.74,4.74,0,0,1,250.05,360.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.25,355.72a4.74,4.74,0,0,1,4.8,4.67l-9.47.13A4.74,4.74,0,0,1,245.25,355.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.2,360.41a2.89,2.89,0,1,1-2.93-2.84A2.88,2.88,0,0,1,248.2,360.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.78,344.87l5.45-3.9a22.78,22.78,0,0,1,5.08-2.71h1.8l-10.91,7.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.68,348.84H234a6.43,6.43,0,0,1,1.37-1.34C236,347.3,236.74,348.06,236.68,348.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M290.7,345.72H255.62l10-6.91a4.26,4.26,0,0,1,2.53-.83h21.75s7.81-.19,9.52,2.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.4,345.74l-1.3-7.32h4.08a13.29,13.29,0,0,1,4.58.87l1.24.54a1.18,1.18,0,0,1,.7.79,1.21,1.21,0,0,1-.22,1L298,343.44a6.1,6.1,0,0,1-4.42,2.28l-.38,0Zm-16.18,0v-7.32h12l1.31,7.32Zm-17.18,0,9-6.74a3,3,0,0,1,1.77-.58H272l-1.41,7.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,359.06v-.53c0-.34,0-.83,0-1.44,0-1.22,0-2.89-.05-4.74,0-.93,0-1.81,0-2.61,0-.41,0-.79,0-1.14a6.31,6.31,0,0,1,0-1,7.26,7.26,0,0,1,.33-1.4,2.47,2.47,0,0,1,.14-.36l0-.1,0,0s0,0,0,0l-.05.09-.14.37a6.14,6.14,0,0,0-.35,1.39,6.37,6.37,0,0,0,0,1v1.14c0,.8,0,1.68,0,2.61,0,1.85.05,3.52.07,4.74,0,.61,0,1.1,0,1.44v.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,346.25l0,0-.08.06-.06,0-.06.07a.85.85,0,0,0-.14.17,4.52,4.52,0,0,0-.61,1.25c-.09.28-.18.6-.26.93,0,.17-.08.35-.11.53a2.16,2.16,0,0,0,0,.57c0,.79,0,1.64,0,2.54.05,1.8.11,3.43.15,4.61,0,.59,0,1.06,0,1.4l0,.38v-.38c0-.34,0-.81,0-1.4,0-1.18-.08-2.81-.13-4.61,0-.9,0-1.76-.05-2.54a3.43,3.43,0,0,1,0-.56c0-.18.07-.36.11-.52a8.85,8.85,0,0,1,.25-.93,4.51,4.51,0,0,1,.59-1.26A2.25,2.25,0,0,1,256.78,346.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.63,346h0a1.19,1.19,0,0,1,.61-1.05l1.58-.89a3,3,0,0,1,1.47-.38h0a2.94,2.94,0,0,1,.94.15,1.69,1.69,0,0,1,1.15,1.57h0a1.74,1.74,0,0,1-1.74,1.8h-2.81A1.2,1.2,0,0,1,255.63,346Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.63,346a1.54,1.54,0,0,0,.18.55,1.26,1.26,0,0,0,1.35.58l2.41,0a1.65,1.65,0,0,0,1.7-1.78,1.62,1.62,0,0,0-.68-1.21,2.39,2.39,0,0,0-1.29-.35,4.26,4.26,0,0,0-2.2.78c-.6.34-1.14.54-1.29.9a1.43,1.43,0,0,0-.18.55.89.89,0,0,1,.1-.59c.16-.4.73-.64,1.3-1,.3-.17.61-.36,1-.55a3,3,0,0,1,1.29-.29,2.53,2.53,0,0,1,1.41.37,1.85,1.85,0,0,1,.77,1.37,1.82,1.82,0,0,1-.55,1.46,1.84,1.84,0,0,1-1.36.52l-2.41,0a1.76,1.76,0,0,1-.93-.17,1.23,1.23,0,0,1-.5-.52A.89.89,0,0,1,255.63,346Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.63,346s0,.05,0,.15a1.32,1.32,0,0,0,.14.41,1.21,1.21,0,0,0,.89.61,3.92,3.92,0,0,0,.49,0h2.41a2,2,0,0,0,.67-.11,1.78,1.78,0,0,0,1-1,1.73,1.73,0,0,0-.61-2,1.63,1.63,0,0,0-.65-.28,3.23,3.23,0,0,0-.68-.08,3.09,3.09,0,0,0-1.24.26l-.51.28-.47.26-.81.45a1.24,1.24,0,0,0-.49.47,1.45,1.45,0,0,0-.14.42c0,.1,0,.15,0,.15a.63.63,0,0,1,0-.16,1.14,1.14,0,0,1,.13-.42,1.22,1.22,0,0,1,.49-.5l.8-.46.47-.26c.16-.09.33-.2.51-.28a3.07,3.07,0,0,1,1.27-.28,3.25,3.25,0,0,1,.69.08,1.87,1.87,0,0,1,.68.29,1.75,1.75,0,0,1,.74,1.31,1.72,1.72,0,0,1-.11.78,1.7,1.7,0,0,1-.42.63,1.79,1.79,0,0,1-.62.4,2,2,0,0,1-.69.11h-2.41a3.92,3.92,0,0,1-.49,0,1.59,1.59,0,0,1-.42-.14,1.22,1.22,0,0,1-.49-.5,1.23,1.23,0,0,1-.13-.43A.57.57,0,0,1,255.63,346Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,344.35s0-.05-.14-.13a.9.9,0,0,0-.46-.19,2,2,0,0,0-.75.08,5.83,5.83,0,0,0-.89.3,6.09,6.09,0,0,0-1.44.9c-.34.28-.52.49-.53.48l.12-.15.37-.37a5.42,5.42,0,0,1,1.45-.92,4.52,4.52,0,0,1,.9-.3,1.92,1.92,0,0,1,.77-.07.9.9,0,0,1,.48.22.27.27,0,0,1,.09.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,360.66v-.32c0-.11,0-.24,0-.4s0-.34,0-.54,0-.43.05-.68,0-.25.06-.38,0-.27.08-.41A9.41,9.41,0,0,1,285,354a9.51,9.51,0,0,1,1.94-1.91,9.24,9.24,0,0,1,2.68-1.35,10.68,10.68,0,0,1,3.18-.48,11.15,11.15,0,0,1,3.19.5,9.85,9.85,0,0,1,2.7,1.33,10.79,10.79,0,0,1,2,1.81,11.85,11.85,0,0,1,1.38,1.94,12.9,12.9,0,0,1,.81,1.79c.05.13.09.27.13.39s.09.25.12.37l.17.66.1.53c0,.15,0,.29.06.39l0,.24a.66.66,0,0,0,0,.09.62.62,0,0,0,0-.09l0-.24a3.79,3.79,0,0,0-.05-.39l-.1-.54c0-.19-.1-.41-.16-.65s-.08-.25-.12-.38-.08-.26-.13-.4a12.28,12.28,0,0,0-.81-1.79,11.41,11.41,0,0,0-3.4-3.78,9.92,9.92,0,0,0-2.71-1.33,10.62,10.62,0,0,0-6.41,0,9.4,9.4,0,0,0-2.7,1.37A9.84,9.84,0,0,0,285,354a10.61,10.61,0,0,0-1.21,2.06,11.44,11.44,0,0,0-.6,1.87c0,.14,0,.28-.07.42l-.06.38c0,.25,0,.47,0,.68v.54c0,.16,0,.29,0,.4l0,.24A.45.45,0,0,1,283,360.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.93,350.65l0,0,.09-.14c.08-.12.18-.29.31-.52a8.48,8.48,0,0,0,.4-.8,1.83,1.83,0,0,0,.08-.25.33.33,0,0,0,0-.14l0-.13c-.06-.18-.13-.36-.2-.54-.29-.72-.58-1.36-.79-1.82l-.26-.55-.07-.15,0-.05a.15.15,0,0,0,0,.06l.06.15.24.55c.2.47.48,1.11.77,1.83.07.18.14.36.2.53a.57.57,0,0,1,0,.25,1.09,1.09,0,0,1-.07.24,8.63,8.63,0,0,1-.39.8l-.29.53-.08.15Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.69,352.91s1.89,0,4.21,0,4.22,0,4.22-.05-1.89,0-4.22,0S299.69,352.89,299.69,352.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.67,359s6.12,0,13.68,0S283,359,283,359s-6.12,0-13.67,0S255.67,358.93,255.67,359Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.73,359s.93,0,2.09,0,2.1,0,2.1,0-.94,0-2.1,0S231.73,359,231.73,359Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.91,348h.17l.51,0,1.85-.17c1.56-.16,3.72-.4,6.1-.73s4.52-.69,6.07-1l1.83-.35.49-.1.13,0,0,0h0l-.13,0-.5.09-1.83.32c-1.55.27-3.69.62-6.07.95s-4.53.59-6.09.75l-1.86.2-.5.05h-.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.39,348.71l-.1,0a.64.64,0,0,1-.5-.43.71.71,0,0,1,0-.26.74.74,0,0,1,.08-.28.63.63,0,0,1,.55-.34H270a.65.65,0,0,1,.42.16.67.67,0,0,1,.2.39.74.74,0,0,1-.08.42.6.6,0,0,1-.3.27.9.9,0,0,1-.4.05h.21a.78.78,0,0,0,.21,0,.68.68,0,0,0,.33-.3.8.8,0,0,0,.09-.46.69.69,0,0,0-.22-.42.65.65,0,0,0-.46-.18h-2.65a.67.67,0,0,0-.58.37.67.67,0,0,0-.08.3.77.77,0,0,0,0,.27.71.71,0,0,0,.54.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.61,347.18a8.25,8.25,0,0,0,1,0,8.35,8.35,0,0,0,1.05,0,8.35,8.35,0,0,0-1.05,0A8.25,8.25,0,0,0,267.61,347.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.73,348.81h-.1a.64.64,0,0,1-.5-.43.75.75,0,0,1,0-.26.79.79,0,0,1,.08-.29.62.62,0,0,1,.55-.33h2.64a.62.62,0,0,1,.62.55.76.76,0,0,1-.08.42.65.65,0,0,1-.3.27.9.9,0,0,1-.4.05h.21a.54.54,0,0,0,.21,0,.66.66,0,0,0,.33-.29A.81.81,0,0,0,288,348a.75.75,0,0,0-.22-.43.7.7,0,0,0-.46-.18h-2.65a.68.68,0,0,0-.58.36.71.71,0,0,0-.08.31.8.8,0,0,0,0,.27.61.61,0,0,0,.28.34.47.47,0,0,0,.26.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285,347.29s.47,0,1,0,1.05,0,1.05,0a8.35,8.35,0,0,0-1.05,0A8.25,8.25,0,0,0,285,347.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.81,360.88v-.33c0-.1,0-.24,0-.39l0-.54c0-.2,0-.43.08-.67s.05-.25.08-.38,0-.27.09-.41a11.18,11.18,0,0,1,.65-1.85,10.91,10.91,0,0,1,1.24-2,10,10,0,0,1,1.94-1.89,9.35,9.35,0,0,1,2.67-1.37,10.36,10.36,0,0,1,6.36,0,9.35,9.35,0,0,1,2.67,1.37,10,10,0,0,1,1.94,1.89,10.91,10.91,0,0,1,1.24,2,11.18,11.18,0,0,1,.65,1.85c0,.14.06.28.09.41s.06.26.08.38.07.47.08.67l0,.54c0,.15,0,.29,0,.39v0c0-.1,0-.24,0-.39s0-.34,0-.54-.06-.43-.08-.68,0-.25-.08-.38-.05-.27-.08-.41a10.87,10.87,0,0,0-.65-1.85,10.41,10.41,0,0,0-1.24-2,10.12,10.12,0,0,0-2-1.91A9.43,9.43,0,0,0,249,351a10.56,10.56,0,0,0-3.2-.5,10.26,10.26,0,0,0-3.2.51,9.16,9.16,0,0,0-2.68,1.37,10.12,10.12,0,0,0-1.95,1.91,10.71,10.71,0,0,0-1.24,2,10.87,10.87,0,0,0-.65,1.85c0,.14,0,.28-.08.41a2.79,2.79,0,0,0-.07.38c0,.25-.07.47-.09.68l0,.54v.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,338h3l7.21,0,4,0c1.22,0,2.32,0,3.24-.06a16,16,0,0,0,2.17-.25c.26-.05.45-.09.58-.13l.15,0,.05,0h-.05l-.15,0-.58.12a16.77,16.77,0,0,1-2.17.23c-.92,0-2,0-3.24,0h-4L290,338l-2.19,0H287Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.68,341.09s1.27.7,2.86,1.53,2.87,1.49,2.88,1.47-1.27-.7-2.86-1.53S278.69,341.07,278.68,341.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,340.55l.06,0,.18.1.67.35c.57.3,1.35.71,2.21,1.18s1.64.9,2.19,1.22l.66.37.18.1.07,0-.06,0-.17-.11-.66-.39c-.55-.33-1.32-.77-2.18-1.23s-1.64-.88-2.22-1.17l-.68-.33-.19-.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.4,341.53l.05,0,.15.07c.14.06.32.15.55.24l1.78.83c.69.34,1.31.65,1.76.89l.53.27.14.07.06,0-.05,0-.14-.08-.52-.29c-.44-.24-1.06-.57-1.75-.9s-1.33-.62-1.8-.81l-.55-.23-.15-.06S264.41,341.52,264.4,341.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.07,341.36l.34.17.8.42.78.47.32.19a1.14,1.14,0,0,0-.3-.23c-.19-.13-.46-.31-.77-.48s-.6-.31-.81-.41A1.71,1.71,0,0,0,266.07,341.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.27,341.3s.84.35,1.89.75,1.9.72,1.91.71-.84-.36-1.89-.76S292.28,341.28,292.27,341.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.36,340.94s.72.3,1.63.63,1.64.59,1.65.57-.72-.3-1.63-.63S293.36,340.93,293.36,340.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.89,350.17H244l.28,0,.19,0h.24c.17,0,.36,0,.58,0H246l.8.06a13.22,13.22,0,0,1,1.8.35,12.7,12.7,0,0,1,1.72.62,8,8,0,0,1,.72.36l.32.17.29.18c.18.1.34.22.48.31l.19.13.16.12.22.16.08.06s0,0-.07-.07l-.21-.17-.16-.12-.19-.14c-.14-.1-.3-.21-.48-.32l-.29-.18-.31-.18-.72-.36a13.35,13.35,0,0,0-1.73-.63,12.11,12.11,0,0,0-1.81-.34L246,350h-.7c-.21,0-.4,0-.57,0l-.24,0-.2,0-.27,0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.53,349.86h.63l.46,0,.26,0,.28,0c.2,0,.41.06.63.1.43.09.91.21,1.4.36s.94.35,1.35.53a11.31,11.31,0,0,1,1,.53l.4.22.29.18.19.11.07,0-.06-.05-.18-.12-.29-.19-.4-.23a11.18,11.18,0,0,0-1.05-.54,11.71,11.71,0,0,0-1.36-.53,12.73,12.73,0,0,0-1.4-.37l-.63-.09-.29,0-.26,0-.46,0h-.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.34,
    y: 235.69,
    width: 64.16,
    height: 9.41,
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 244.34,
    y: 235.69,
    width: 64.16,
    height: 9.41
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M246.77,245a6.19,6.19,0,1,0,6.28-6.1A6.19,6.19,0,0,0,246.77,245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.77,244.94v0a6.19,6.19,0,0,0,12.37.17h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.61,245A4.35,4.35,0,1,0,253,240.7,4.35,4.35,0,0,0,248.61,245Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,240.7a4.35,4.35,0,0,0-4.41,4.28l8.69.13A4.35,4.35,0,0,0,253,240.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.31,245A2.65,2.65,0,1,0,253,242.4,2.65,2.65,0,0,0,250.31,245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.08,245a6.19,6.19,0,1,0,6.27-6.1A6.18,6.18,0,0,0,294.08,245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.08,244.94v0a6.19,6.19,0,1,0,12.37.17h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.92,245a4.35,4.35,0,1,0,4.41-4.28A4.35,4.35,0,0,0,295.92,245Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.33,240.7a4.35,4.35,0,0,0-4.41,4.28l8.69.13A4.36,4.36,0,0,0,300.33,240.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.62,245a2.65,2.65,0,1,0,2.68-2.61A2.64,2.64,0,0,0,297.62,245Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.07,230.4s-9.11.67-12.49,1.43c-2.38.53-7,1.45-6.91,4.34l.36,2.07a3.12,3.12,0,0,0-1.7,2.76c0,2-.42,5.06,3.55,5.18.66,0,1.9,0,1.9,0s-.76-8.46,7-8.71,7.39,8.64,7.39,8.64h33s-1.35-8.66,7.16-8.67,7.22,8.72,7.22,8.72a5,5,0,0,0,4.59-2.36,7.14,7.14,0,0,0,1.08-4.5l-.05-1.67a1.08,1.08,0,0,0-1-1h0s.57-4.19-.3-4.92-5.66-5.1-5.66-5.1l.23-.14a.54.54,0,0,0-.11-1l-6.25-2.16a1.77,1.77,0,0,0-.4-.08c-.5,0-1.93-.13-4.55-.16-3.19,0-15.85,0-15.85,0a27.18,27.18,0,0,0-6.79,1.43C269.91,225.63,261.07,230.4,261.07,230.4Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.64,240.77a1.41,1.41,0,0,0-1.09.15,1.06,1.06,0,0,0-.27.68,2.74,2.74,0,0,0,0,1,1.27,1.27,0,0,0,.57.82.81.81,0,0,0,1-.12,1.28,1.28,0,0,0,.23-.88,6.72,6.72,0,0,0-.06-1.27.47.47,0,0,0-.11-.25.34.34,0,0,0-.26-.16"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242,238.24c1,0,1.91-.05,2.87-.12a.48.48,0,0,0,.29-.09c.1-.08.1-.22.11-.35a1.87,1.87,0,0,0-.42-1.45,1.6,1.6,0,0,0-.88-.3,5.73,5.73,0,0,0-2.33.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M262.11,245.84a.45.45,0,0,0,0-.08v-.24c0-.22,0-.53,0-.94s-.05-.9-.11-1.47a11.82,11.82,0,0,0-.34-1.92,8.92,8.92,0,0,0-.93-2.17,7,7,0,0,0-1.8-2,10.5,10.5,0,0,0-5.88-1.77,9.58,9.58,0,0,0-5.83,1.84,8.61,8.61,0,0,0-1.89,1.93,8.85,8.85,0,0,0-1.11,2.09,8.53,8.53,0,0,0-.47,1.89,8.64,8.64,0,0,0-.06,1.47,8.06,8.06,0,0,0,.12.93l0,.24a.45.45,0,0,1,0,.08.45.45,0,0,0,0-.08l-.05-.24a7,7,0,0,1-.08-2.4,8.1,8.1,0,0,1,.46-1.91,8.91,8.91,0,0,1,1.11-2.1,8.49,8.49,0,0,1,1.9-1.94,9.56,9.56,0,0,1,5.86-1.86,10.53,10.53,0,0,1,5.91,1.78,6.91,6.91,0,0,1,1.81,2,8.76,8.76,0,0,1,.93,2.18,11.09,11.09,0,0,1,.33,1.94c.06.57.08,1.07.1,1.47s0,.72,0,.94v.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.46,246v-.28c0-.18,0-.45,0-.8,0-.7-.05-1.73-.09-3s-.08-2.89-.13-4.71c0-.45,0-.92,0-1.4a6.19,6.19,0,0,1,0-.74l.06-.37.07-.37a8.06,8.06,0,0,1,1.36-2.89h0l5.72-3.6,1.54-1a11.74,11.74,0,0,1,1.63-.91,16.09,16.09,0,0,1,1.78-.71c.3-.11.61-.19.92-.29s.63-.17.95-.23a21.27,21.27,0,0,1,3.69-.46,32.48,32.48,0,0,1,3.56,0h0v0c-.55,2.45-1.06,4.76-1.54,6.87h0a7.34,7.34,0,0,0-.69,1.48,4,4,0,0,0-.23,1.52c0,.51.05,1,.06,1.49s0,1,0,1.4c0,1.82,0,3.4,0,4.71v4.1a.42.42,0,0,0,0-.07v-1c0-.7,0-1.73,0-3s0-2.89-.05-4.7q0-.69,0-1.41c0-.48,0-1-.07-1.48a4.14,4.14,0,0,1,.23-1.55,8.06,8.06,0,0,1,.7-1.49h0c.47-2.11,1-4.42,1.53-6.87l0,0a32.48,32.48,0,0,0-3.56,0,21,21,0,0,0-3.67.46c-.32.06-.64.15-.95.23s-.62.18-.92.29a17.14,17.14,0,0,0-1.77.7,12.87,12.87,0,0,0-1.63.91l-1.54,1-5.72,3.6h0a7.27,7.27,0,0,0-.85,1.4,8,8,0,0,0-.51,1.47,10.8,10.8,0,0,0-.13,2.87c.05,1.82.09,3.4.12,4.71s.06,2.33.07,3c0,.35,0,.62,0,.8V246Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.45,224.42h.83l2.28-.05,7.67-.13h0c.34.43.71.87,1.07,1.32l3.08,3.77c.11.14.23.28.34.43a2.22,2.22,0,0,1,.29.46,2.39,2.39,0,0,1,.23,1,2.3,2.3,0,0,1-.18.95l-.35.81c-.45,1-.81,1.88-1.07,2.46l-.29.67-.07.17,0,.06a.12.12,0,0,1,0-.06l.07-.18.28-.67L298.7,233a4.31,4.31,0,0,0,.52-1.75,2.3,2.3,0,0,0-.23-1,2.11,2.11,0,0,0-.28-.45l-.35-.43-3.07-3.76-1.08-1.32h0l-7.68.11-2.28,0h-.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.58,234.63h.09a.65.65,0,0,0,.24-.1.59.59,0,0,0,.25-.32.55.55,0,0,0,0-.26.54.54,0,0,0-.07-.27.6.6,0,0,0-.53-.33H277a.58.58,0,0,0-.4.16.62.62,0,0,0-.2.38.69.69,0,0,0,.08.4.59.59,0,0,0,.29.27,1,1,0,0,0,.39,0H277a.8.8,0,0,1-.21,0,.69.69,0,0,1-.32-.29.75.75,0,0,1-.09-.44.69.69,0,0,1,.22-.42.64.64,0,0,1,.44-.17h2.57a.68.68,0,0,1,.57.36.62.62,0,0,1,.07.29.77.77,0,0,1,0,.27.6.6,0,0,1-.26.33.73.73,0,0,1-.26.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.69,234.63h.09a.72.72,0,0,0,.24-.1.64.64,0,0,0,.25-.32,1,1,0,0,0,0-.26.68.68,0,0,0-.07-.27.62.62,0,0,0-.53-.33h-2.57a.62.62,0,0,0-.41.16.56.56,0,0,0-.19.38.61.61,0,0,0,.07.4.65.65,0,0,0,.3.27,1,1,0,0,0,.38,0h-.2a.65.65,0,0,1-.2,0,.72.72,0,0,1-.33-.29.74.74,0,0,1-.08-.44.68.68,0,0,1,.21-.42.66.66,0,0,1,.45-.17h2.57a.7.7,0,0,1,.57.36.75.75,0,0,1,0,.56.66.66,0,0,1-.27.33.69.69,0,0,1-.25.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.69,231.84h-3.43a1.25,1.25,0,0,0-1.11.67h0a1.25,1.25,0,0,0,0,1.1l1.34,3,3.43,0S312.61,232.76,311.69,231.84Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.15,231.41l17.66-.33,11.49-.21,3.8-2.19a.59.59,0,0,0,.17-.86l-2.36-3.1a1.29,1.29,0,0,0-1-.52L281,224.09a18,18,0,0,0-8.66,1.86A82.09,82.09,0,0,0,264.15,231.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.24,224.41s.89.41.31.78-9.52,6-9.52,6l-2.06-.93C264.61,228.25,268.3,226.28,272.24,224.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.32,231.35h-.06l-.16,0-.63.13c-.54.11-1.34.26-2.32.43-2,.34-4.68.73-7.71,1-.75.07-1.49.12-2.21.17s-1.4.09-2.06.15a16.9,16.9,0,0,0-3.43.59,9.38,9.38,0,0,0-2.17.9c-.24.13-.42.26-.54.33l-.15.09,0,0,0,0,.14-.1a4.91,4.91,0,0,1,.54-.34,9.28,9.28,0,0,1,2.17-.92,17.63,17.63,0,0,1,3.44-.61c.65-.06,1.34-.1,2.06-.15s1.45-.1,2.21-.17c3-.26,5.74-.65,7.71-1l2.32-.41.63-.12.16,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.05,239.26s-1.17,0-2.62,0-2.63,0-2.63,0,1.17,0,2.63,0S313.05,239.24,313.05,239.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.52,242.26s-6.65,0-14.84,0-14.84,0-14.84,0,6.64,0,14.84,0S291.52,242.25,291.52,242.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,239.36s-.94,0-2.09,0-2.1,0-2.1,0,.94,0,2.1,0S245,239.34,245,239.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.09,226.45s-.79.89-.48,1.53,3.51,2.92,3.51,2.92l2.33.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.98 224.87 283.45 230.52 292.81 230.25 296.58 228.06 294.14 224.87 283.98 224.87",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.37,230.81s5.64-4.08,7.87-4.89a14.11,14.11,0,0,1,5.29-1c1.93-.06,3.1,0,3.1,0l-1.49,5.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.54,230.83h0a1,1,0,0,1,.5-.86l1.3-.73a2.46,2.46,0,0,1,1.21-.32h0a2.53,2.53,0,0,1,.77.12,1.42,1.42,0,0,1,.95,1.29h0a1.44,1.44,0,0,1-1.43,1.49h-2.31A1,1,0,0,1,265.54,230.83Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.54,230.83a1.09,1.09,0,0,0,0,.12.82.82,0,0,0,.12.34.89.89,0,0,0,.4.39.86.86,0,0,0,.33.11h2.38a1.42,1.42,0,0,0,1-.4,1.56,1.56,0,0,0,.33-.5,1.39,1.39,0,0,0,.08-.61,1.43,1.43,0,0,0-.58-1,1.52,1.52,0,0,0-.54-.23,2.67,2.67,0,0,0-.56-.06,2.37,2.37,0,0,0-1,.22,4.13,4.13,0,0,0-.42.22l-.39.21-.66.37a1,1,0,0,0-.4.39.94.94,0,0,0-.13.47.45.45,0,0,1,0-.13,1,1,0,0,1,.11-.35,1,1,0,0,1,.4-.41l.66-.37.38-.22c.14-.07.27-.16.43-.23a2.47,2.47,0,0,1,1-.23,2.36,2.36,0,0,1,.58.07,1.43,1.43,0,0,1,1.16,1.31,1.39,1.39,0,0,1-.09.64,1.42,1.42,0,0,1-.34.52,1.46,1.46,0,0,1-.51.32,1.67,1.67,0,0,1-.57.1h-2.39a1,1,0,0,1-.34-.12,1,1,0,0,1-.4-.41.87.87,0,0,1-.11-.34A.41.41,0,0,1,265.54,230.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,245.89v-.08l0-.23c0-.1,0-.23,0-.38v-.52c0-.2,0-.42,0-.66s0-.5,0-.77a10,10,0,0,0-.33-1.86,9.29,9.29,0,0,0-.37-1,7.65,7.65,0,0,0-.56-1,7,7,0,0,0-1.81-1.89,8.69,8.69,0,0,0-2.59-1.27,10.71,10.71,0,0,0-3.08-.42,10.38,10.38,0,0,0-3.08.45,8.77,8.77,0,0,0-1.37.57,8.09,8.09,0,0,0-1.19.77,10.43,10.43,0,0,0-1.83,1.88,7.84,7.84,0,0,0-.61,1,10.5,10.5,0,0,0-.42,1,12.36,12.36,0,0,0-.67,3.25q0,.58,0,.9v.23l0-.23a8.4,8.4,0,0,1,0-.91,12.26,12.26,0,0,1,.65-3.25,9.7,9.7,0,0,1,.42-1,7.94,7.94,0,0,1,.61-1,10.22,10.22,0,0,1,1.84-1.89,7.4,7.4,0,0,1,1.19-.78,8.35,8.35,0,0,1,1.38-.57,10.2,10.2,0,0,1,3.1-.46,10.9,10.9,0,0,1,3.1.42,8.61,8.61,0,0,1,2.61,1.29,8.86,8.86,0,0,1,1,.9,6.2,6.2,0,0,1,.79,1,6.78,6.78,0,0,1,.56,1.06,8.28,8.28,0,0,1,.37,1,10.17,10.17,0,0,1,.33,1.86c0,.28,0,.54,0,.78v.66l0,.52a3.45,3.45,0,0,1,0,.38l0,.23A.2.2,0,0,1,309,245.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.89,231.41h-.4l-1.11,0-3.66.09c-1.43,0-2.72.07-3.66.07H271l1.11,0,3.66-.09c1.43,0,2.72-.07,3.66-.07q.71,0,1.11,0h.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.35,
    cy: 233.15,
    rx: 1.01,
    ry: 0.03,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.73,227s-1.25.54-2.81,1.17-2.82,1.13-2.83,1.11,1.25-.54,2.81-1.17S279.73,226.94,279.73,227Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.18,227.35s-1.19.55-2.67,1.18-2.69,1.14-2.7,1.12,1.19-.54,2.68-1.17S277.18,227.34,277.18,227.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.35,226.74s-1.26.54-2.81,1.17S287.71,229,287.7,229s1.26-.54,2.81-1.17S293.34,226.72,293.35,226.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.8,227.13s-1.19.55-2.68,1.18-2.69,1.14-2.7,1.13,1.19-.55,2.68-1.18S290.79,227.12,290.8,227.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.59,231.41s-2.5,0-5.58.06-5.59,0-5.59,0,2.5,0,5.58-.06S293.59,231.39,293.59,231.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.36,233.05s-.7,0-1.57,0-1.56,0-1.56,0,.7,0,1.56-.05S296.36,233,296.36,233.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.47,232.19l-.07,0-.19,0-.31.05-.41.06c-.3.06-.66.13-1.05.24a13,13,0,0,0-1.25.41,11.27,11.27,0,0,0-1.2.55q-.54.28-.93.54l-.35.23-.25.18-.16.11-.06,0,0,0,.15-.12.26-.19L243,234c.25-.17.57-.36.92-.55a11.47,11.47,0,0,1,1.21-.55,10.67,10.67,0,0,1,1.25-.41,10.42,10.42,0,0,1,1.06-.23l.41-.06.31,0h.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.12,229.47a.44.44,0,0,0-.11-.11.9.9,0,0,0-.38-.16,1.76,1.76,0,0,0-.62.07,4.86,4.86,0,0,0-.73.25,4.63,4.63,0,0,0-1.18.74c-.28.23-.42.4-.43.39a.71.71,0,0,1,.1-.12,2.05,2.05,0,0,1,.3-.31,4.53,4.53,0,0,1,1.19-.76,3.74,3.74,0,0,1,.74-.24,1.58,1.58,0,0,1,.63-.06.71.71,0,0,1,.39.18l.08.09A.06.06,0,0,1,269.12,229.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.35,226.41a1.91,1.91,0,0,1-.49.05,2.67,2.67,0,0,1-.58-.07,4.7,4.7,0,0,1-.74-.23c-.26-.1-.55-.22-.86-.36l-.48-.19-.51-.19a21.07,21.07,0,0,0-2.36-.64,27.42,27.42,0,0,0-4.4-.55l-.77,0h-1l.37,0h1.35a26,26,0,0,1,4.41.53,19.76,19.76,0,0,1,2.37.65c.17.07.35.12.51.19l.48.2c.31.13.59.26.86.36a4.42,4.42,0,0,0,.73.24,3.51,3.51,0,0,0,.57.08h.36l.1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.82,
    y: 297.43,
    width: 76.61,
    height: 8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 232.82,
    y: 297.43,
    width: 76.61,
    height: 8
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M231.05,305.31s-1.51-.59-1.6-1.51,0-3.37,0-3.37,1.79-6.16,2-6.92,1.67-2,3.43-2.76l6.39-2.7h1.53s11-9.41,14.72-9.83c0,0,13.1-.84,25.3-.51s25-.17,25.61.51c0,0,1.68,5.89,2.52,10.77a73.54,73.54,0,0,1,.5,12.45s.85,0,.76,1.77-.33,1.85-1.34,2.1a67.64,67.64,0,0,1-7.16,0s.26-7.74-6.64-7.82-7.66,6.64-7.49,8.41l-38.46.5s-.82-8.84-7.8-8.84c-8,0-6.77,8.9-6.75,8.84S232,306.91,231.05,305.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.78,285.35s-4.14,3.52-3.87,4.09c.12.27,4.42.15,4.42.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.85,279.67c-.81.23-2.17.2-4.75,2.61-.88.82-2.09,2-3.32,3.07l.55,4.24,14.38-.13.63-10.23S259.35,279.54,258.85,279.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.85,279.67l.13,0,.39,0,1.49-.11c1.3-.08,3.17-.18,5.48-.29h0v0c-.17,2.83-.38,6.34-.62,10.23v0h0l-5.46.06-8.92.07h0v0c-.2-1.51-.38-2.92-.55-4.24v0h0l3-2.8c.45-.42.87-.8,1.29-1.13a11.85,11.85,0,0,1,1.19-.83,6.38,6.38,0,0,1,1.88-.75l.52-.11.13,0h.05l-.18.05-.52.12a6.36,6.36,0,0,0-1.86.77,10.35,10.35,0,0,0-1.18.83c-.41.33-.84.71-1.28,1.13l-3,2.81v0c.17,1.32.36,2.73.55,4.24l0,0,8.92-.08,5.46-.05,0,0c.24-3.89.46-7.39.64-10.23l0,0c-2.31.09-4.18.18-5.48.26l-1.49.09-.39,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.49,293.51s4.23-.71,5.26-.67A4.21,4.21,0,0,1,238,293s-2.22,2.83-2.9,3a32.31,32.31,0,0,1-4.32,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.56,288.05l0,.09-.12.25a3.61,3.61,0,0,1-.57.82,4.32,4.32,0,0,1-1.21.86c-.49.25-1.06.48-1.66.72a27.83,27.83,0,0,0-3,1.36l-.87.48-.24.13s-.08.05-.09,0l.08-.05.23-.15c.2-.12.49-.3.86-.5a24,24,0,0,1,3-1.39c.6-.24,1.17-.46,1.66-.71a4.43,4.43,0,0,0,1.2-.83,3.79,3.79,0,0,0,.58-.8l.13-.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.13,279.12h.56l-11.13,8.93h-1.72s2.45-2.12,5.17-4.19C250.92,281.64,254.05,279.48,255.13,279.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.39,285.77a4.92,4.92,0,0,1,.84,2.76,1,1,0,0,1-1,.91h-2.81s-.53-.46-.28-1,.47-.42.47-.42S249.78,285.7,251.39,285.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.87,292.12s-16.32.23-36.46.47S238,293,238,293s16.32-.23,36.45-.47S310.87,292.1,310.87,292.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.41,302.45s-8.44.13-18.85.25-18.85.18-18.85.16,8.44-.14,18.85-.25S289.41,302.43,289.41,302.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.07,302.86v-.95c0-.62,0-1.5,0-2.58,0-2.18-.08-5.2-.14-8.52s-.11-6.34-.12-8.53c0-1.09,0-2,0-2.58v-.94a.28.28,0,0,0,0,.06v.88c0,.62,0,1.5,0,2.58,0,2.19.07,5.2.14,8.53s.11,6.33.12,8.52v2.58c0,.3,0,.54,0,.7v.18A.24.24,0,0,1,268.07,302.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,288.72l-35,.62,0-10.11,34.06.31c.17-.11.59.24.68.72l1.31,7.14A1.11,1.11,0,0,1,304,288.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,288.72l.17,0a1,1,0,0,0,.48-.19,1.17,1.17,0,0,0,.44-.7,1.42,1.42,0,0,0,0-.54l-.12-.61c-.16-.87-.36-1.93-.59-3.18-.12-.63-.24-1.3-.38-2-.06-.36-.13-.73-.2-1.11a1.27,1.27,0,0,0-.2-.53,1.34,1.34,0,0,0-.2-.21l-.13-.07a.16.16,0,0,0-.12,0h0L269,279.28l0,0v.36c0,3.36,0,6.63,0,9.75l0,0,25-.43,7.33-.12,2,0h0l-2,0-7.33.15-25,.45h0v0c0-3.12,0-6.39,0-9.75v-.4H269l34.06.32h0a.25.25,0,0,1,.17,0l.14.08a1.1,1.1,0,0,1,.21.22,1.24,1.24,0,0,1,.21.55c.07.38.14.75.2,1.11.13.71.25,1.38.37,2,.23,1.25.42,2.32.58,3.19l.11.61a1.25,1.25,0,0,1,0,.54,1.14,1.14,0,0,1-.46.71,1,1,0,0,1-.48.19H304Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.8,292.26l.13,5.17h2.41s-.12-3.49-.17-4.66a.41.41,0,0,0-.37-.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.24,302.69s0,0,0-.05l-.06-.17c0-.07-.06-.17-.1-.27l-.14-.37c-.12-.28-.27-.61-.47-1a11,11,0,0,0-.75-1.22,10.27,10.27,0,0,0-2.66-2.58,8.76,8.76,0,0,0-4.28-1.44,8,8,0,0,0-4.41.92,8,8,0,0,0-3.79,4.76l-.1.38c0,.11,0,.21-.06.28l0,.18a.32.32,0,0,1,0,.06.28.28,0,0,1,0-.06l0-.18a2,2,0,0,1,.05-.29c0-.11.05-.24.09-.38a7.61,7.61,0,0,1,1.05-2.3,7.9,7.9,0,0,1,2.73-2.52,8.16,8.16,0,0,1,4.45-.94,9,9,0,0,1,4.32,1.46,10.26,10.26,0,0,1,2.67,2.62,11.64,11.64,0,0,1,.75,1.23q.28.57.45,1l.14.37c0,.11.06.2.09.28l0,.17A.18.18,0,0,1,252.24,302.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.29,301.72a.18.18,0,0,0,0-.05l0-.16-.06-.25-.05-.15-.06-.18-.14-.42q-.1-.21-.21-.48c-.08-.17-.19-.34-.29-.52s-.24-.37-.37-.56a6.33,6.33,0,0,0-2.6-2,2.87,2.87,0,0,0-.44-.17l-.46-.15a9.19,9.19,0,0,0-1-.22c-.34-.06-.68-.09-1-.12-.17,0-.35,0-.53,0h-.54a7.3,7.3,0,0,0-2.05.38,8.49,8.49,0,0,0-1.77.83,8.86,8.86,0,0,0-1.42,1,8.31,8.31,0,0,0-1,1.15,6.36,6.36,0,0,0-1,2c0,.13-.06.24-.08.34a1.57,1.57,0,0,0-.05.25l0,.16a.18.18,0,0,0,0,.05,4.22,4.22,0,0,1,.14-.81,6.32,6.32,0,0,1,1-2,8.36,8.36,0,0,1,1-1.16,9,9,0,0,1,1.43-1.07,8.59,8.59,0,0,1,1.78-.84,7.1,7.1,0,0,1,2.08-.39,4.87,4.87,0,0,1,.54,0c.18,0,.36,0,.54,0,.35,0,.7.06,1,.13s.67.14,1,.22l.46.15c.15.05.3.12.44.18a6.3,6.3,0,0,1,2.62,2c.13.2.26.38.37.57s.2.36.28.53.14.34.21.49.09.29.13.42l.06.18,0,.16.06.25,0,.15A.28.28,0,0,1,304.29,301.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.15,301.85h-.24l-.66,0-2.18-.06-2.17,0h-.66l-.24,0,.24,0,.66,0c.55,0,1.33,0,2.18,0s1.62.05,2.17.08l.66.05A.75.75,0,0,1,311.15,301.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.36,304.73a6.5,6.5,0,1,0,6.59-6.4A6.49,6.49,0,0,0,290.36,304.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.36,304.71v0a6.5,6.5,0,1,0,13,.19v0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.29,304.76a4.56,4.56,0,1,0,4.63-4.5A4.56,4.56,0,0,0,292.29,304.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.92,300.26a4.57,4.57,0,0,0-4.63,4.5l9.12.13A4.56,4.56,0,0,0,296.92,300.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.07,304.78a2.78,2.78,0,1,0,2.82-2.73A2.78,2.78,0,0,0,294.07,304.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86,304.73a6.5,6.5,0,1,0,6.59-6.4A6.5,6.5,0,0,0,236.86,304.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.87,304.71v0a6.5,6.5,0,1,0,13,.19v0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.8,304.76a4.56,4.56,0,1,0,4.62-4.5A4.54,4.54,0,0,0,238.8,304.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.42,300.26a4.57,4.57,0,0,0-4.62,4.5l9.12.13A4.57,4.57,0,0,0,243.42,300.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.58,304.78a2.78,2.78,0,1,0,2.82-2.73A2.77,2.77,0,0,0,240.58,304.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.23,289.44s-.1,0-.22-.1a.91.91,0,0,1-.35-.48,2.13,2.13,0,0,1,0-.59.68.68,0,0,1,0-.24,1.05,1.05,0,0,1,0,.24,3.15,3.15,0,0,0,.06.56,1,1,0,0,0,.31.46C249.16,289.39,249.24,289.43,249.23,289.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.37,282.21s-1.47,1.25-3.32,2.74-3.36,2.69-3.37,2.68,1.47-1.25,3.32-2.74S263.36,282.19,263.37,282.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.43,282.7s-.72.59-1.64,1.27a19.64,19.64,0,0,1-1.7,1.2s.73-.58,1.65-1.27S261.42,282.68,261.43,282.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.86,281s-1.25,1.18-2.83,2.6-2.86,2.57-2.88,2.55,1.25-1.19,2.83-2.61S282.84,280.93,282.86,281Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.71,282.49s-.56.53-1.27,1.16a15,15,0,0,1-1.33,1.1s.55-.54,1.27-1.16A15,15,0,0,1,279.71,282.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.63,281.8l-.12.16-.32.42-1.11,1.35L294,285.07l-.35.4c-.09.1-.13.15-.14.14l.11-.16.33-.41,1.11-1.36,1.13-1.34.35-.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.52,280.48a.28.28,0,0,1,0,.07l-.11.22c-.1.18-.26.44-.45.76-.39.63-.95,1.5-1.62,2.41s-1.32,1.72-1.81,2.28l-.59.66-.17.17-.06.06s0,0,.05-.07l.15-.19.57-.67c.48-.57,1.12-1.37,1.79-2.29s1.24-1.77,1.64-2.4l.47-.74.13-.2C298.5,280.5,298.51,280.48,298.52,280.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,288s-1.51.05-3.38.05-3.37,0-3.37,0,1.51,0,3.37-.05S248,288,248,288Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.5,302.49s1.3,0,2.91,0,2.91,0,2.91,0-1.3,0-2.91,0S229.5,302.51,229.5,302.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.8,302.45v-.2c0-.13,0-.33,0-.58q0-.78,0-2.25c0-1.95-.06-4.77-.11-8.25,0-1.75,0-3.66-.07-5.71,0-1,0-2.08,0-3.17,0-.55,0-1.1,0-1.66s0-1.14,0-1.71a.29.29,0,0,0-.07-.18.62.62,0,0,0-.16-.1,1.48,1.48,0,0,0-.42-.07l-.88,0h-1.79l-3.69.05-7.76.11-8.32.12-3.93.07c-.64,0-1.27,0-1.89.06a7.28,7.28,0,0,0-1.81.29c-.29.08-.58.17-.86.27l-.43.15-.4.17a11,11,0,0,0-1.46.94c-.92.67-1.76,1.38-2.56,2.07s-1.56,1.37-2.27,2c-.36.32-.71.65-1.06.95a2.32,2.32,0,0,0-.45.49,1.12,1.12,0,0,0-.21.6h0c-.12,3.1-.2,5.57-.26,7.28l-.08,1.95,0,.5a1.15,1.15,0,0,1,0,.17v-.17l0-.5c0-.45,0-1.11.06-1.95.05-1.71.13-4.18.23-7.28h0a1.29,1.29,0,0,1,.22-.63,2.79,2.79,0,0,1,.46-.51c.35-.3.7-.62,1.06-.95.71-.65,1.46-1.33,2.26-2s1.65-1.41,2.57-2.08a10.51,10.51,0,0,1,1.47-.94c.13-.06.27-.13.41-.18l.42-.15q.42-.15.87-.27a7.87,7.87,0,0,1,1.82-.3c.63,0,1.26-.05,1.9-.06l3.93-.07,8.32-.12,7.76-.11,3.69,0H287l.88,0a1.27,1.27,0,0,1,.44.08.51.51,0,0,1,.2.12.34.34,0,0,1,.08.23c0,.58,0,1.14,0,1.7s0,1.12,0,1.67c0,1.09,0,2.15,0,3.17,0,2.05,0,4,.06,5.7,0,3.49.06,6.31.08,8.26,0,1,0,1.73,0,2.25,0,.25,0,.45,0,.58A1.57,1.57,0,0,1,288.8,302.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,291.48h.1a.56.56,0,0,0,.24-.14.52.52,0,0,0,.14-.4.48.48,0,0,0-.36-.4,1.83,1.83,0,0,0-.34,0h-3.15a.46.46,0,0,0-.42.65.49.49,0,0,0,.32.26.87.87,0,0,0,.23,0h1.79l1.06,0h-2.85a1,1,0,0,1-.24,0,.55.55,0,0,1-.39-.31.54.54,0,0,1,0-.51.57.57,0,0,1,.46-.25h3.15a1.35,1.35,0,0,1,.35,0,.51.51,0,0,1,.39.45.49.49,0,0,1-.16.43.45.45,0,0,1-.26.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.88,290.35a11.32,11.32,0,0,1-1.53,0,11.2,11.2,0,0,1-1.53,0s.68,0,1.53,0S264.88,290.33,264.88,290.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.06,287.74a.86.86,0,0,1,.14-.32,3.07,3.07,0,0,1,.5-.65,2.81,2.81,0,0,1,.67-.49.94.94,0,0,1,.31-.13,5.45,5.45,0,0,0-.92.68A4.94,4.94,0,0,0,249.06,287.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.47,282.19s-.56.43-1.27.93a15.3,15.3,0,0,1-1.32.85s.56-.43,1.27-.92A11.67,11.67,0,0,1,261.47,282.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.63,278.45s-2.28,0-5.1,0-5.1,0-5.1,0,2.28,0,5.1,0S279.63,278.43,279.63,278.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.91,288.54l-.19.1-.5.24c-.43.2-1,.46-1.7.74s-1.27.51-1.72.67l-.53.19c-.12,0-.19.06-.19,0l.18-.09.52-.21,1.71-.69,1.7-.71.52-.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.23,295.76h-.37a9.21,9.21,0,0,0-1,0,8.32,8.32,0,0,0-3.18,1,8.21,8.21,0,0,0-2.53,2.13,7.82,7.82,0,0,0-.58.83c-.07.1-.11.19-.15.24l0,.08,0-.09c0-.06.07-.14.13-.24a7.48,7.48,0,0,1,.56-.85,7.83,7.83,0,0,1,5.76-3.1,6.94,6.94,0,0,1,1,0l.28,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.7,303.17a3,3,0,0,1,0-.87,3.13,3.13,0,0,1,.17-.86s0,.39-.09.86A6.09,6.09,0,0,1,235.7,303.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.81,297.3s-.1.25-.25.64a11.75,11.75,0,0,0-.47,1.57,11.91,11.91,0,0,0-.26,1.63c0,.42-.05.68-.06.68a1.23,1.23,0,0,1,0-.18c0-.12,0-.29,0-.5a10,10,0,0,1,.23-1.64,9.5,9.5,0,0,1,.51-1.58,4.37,4.37,0,0,1,.21-.46A.65.65,0,0,1,230.81,297.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.43,292.67s-2,0-4.54,0-4.54,0-4.54,0,2,0,4.54,0S257.43,292.65,257.43,292.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.93,292.4s-2.93,0-6.54,0-6.53,0-6.53,0,2.92,0,6.53,0S282.93,292.38,282.93,292.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.37,296.12h-.09l-.27,0-.41-.06c-.17,0-.35-.05-.56-.06l-.67-.05h-.78a16.59,16.59,0,0,0-1.77.13,15,15,0,0,0-1.73.36c-.27.07-.52.14-.75.22a6.48,6.48,0,0,0-.63.23,5.58,5.58,0,0,0-.52.21l-.38.17-.25.11-.08,0,.07-.05.24-.12.38-.19c.15-.06.32-.15.52-.22l.63-.24.75-.23a15.66,15.66,0,0,1,1.74-.36,14.49,14.49,0,0,1,1.78-.13l.78,0c.25,0,.47,0,.68.06l.55.07a2.87,2.87,0,0,1,.42.08l.26,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.75,303.48s-7.06,0-15.78,0-15.78,0-15.78,0,7.06,0,15.78,0S284.75,303.46,284.75,303.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.81,231.21c0,.14-11.14.26-24.88.26s-24.89-.12-24.89-.26,11.14-.26,24.89-.26S222.81,231.06,222.81,231.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.67,237.07a103.91,103.91,0,0,1-10.5.26,104,104,0,0,1-10.51-.26c0-.14,4.7-.26,10.51-.26S193.67,236.93,193.67,237.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.85,244.94c0,.14-11.46.26-25.59.26s-25.6-.12-25.6-.26,11.46-.26,25.6-.26S223.85,244.8,223.85,244.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.52,233a6.24,6.24,0,1,0-11.63,3.15h0l0,0c.24.41.54.7.84,1.12l3.62,4.8a1.13,1.13,0,0,0,1.8,0l3.57-4.72a13.13,13.13,0,0,0,.9-1.2l0,0h0A6.16,6.16,0,0,0,162.52,233Zm-6.25,2.72A2.75,2.75,0,1,1,159,233,2.75,2.75,0,0,1,156.27,235.73Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.57 220.77 175.48 222.6 177.49 222.89 176.03 224.31 176.38 226.32 174.57 225.37 172.77 226.32 173.12 224.31 171.66 222.89 173.67 222.6 174.57 220.77",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.11 220.77 184.01 222.6 186.03 222.89 184.57 224.31 184.91 226.32 183.11 225.37 181.31 226.32 181.65 224.31 180.19 222.89 182.21 222.6 183.11 220.77",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.64 220.77 192.54 222.6 194.56 222.89 193.1 224.31 193.45 226.32 191.64 225.37 189.84 226.32 190.19 224.31 188.73 222.89 190.74 222.6 191.64 220.77",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.18 220.77 201.08 222.6 203.09 222.89 201.64 224.31 201.98 226.32 200.18 225.37 198.38 226.32 198.72 224.31 197.26 222.89 199.28 222.6 200.18 220.77",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.71 220.77 209.61 222.6 211.63 222.89 210.17 224.31 210.51 226.32 208.71 225.37 206.91 226.32 207.25 224.31 205.79 222.89 207.81 222.6 208.71 220.77",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.81,351.36c0,.14-11.14.26-24.88.26S173,351.5,173,351.36s11.14-.26,24.89-.26S222.81,351.22,222.81,351.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.67,357.22a103.91,103.91,0,0,1-10.5.26,104,104,0,0,1-10.51-.26c0-.14,4.7-.26,10.51-.26S193.67,357.08,193.67,357.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.85,365.09c0,.15-11.46.26-25.59.26s-25.6-.11-25.6-.26,11.46-.26,25.6-.26S223.85,365,223.85,365.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.52,353.16a6.24,6.24,0,1,0-11.63,3.15h0l0,0c.24.4.54.69.84,1.11l3.62,4.8a1.13,1.13,0,0,0,1.8,0l3.57-4.72a13.13,13.13,0,0,0,.9-1.2l0,0h0A6.13,6.13,0,0,0,162.52,353.16Zm-6.25,2.72a2.75,2.75,0,1,1,2.75-2.75A2.75,2.75,0,0,1,156.27,355.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.57 340.93 175.48 342.75 177.49 343.05 176.03 344.47 176.38 346.47 174.57 345.53 172.77 346.47 173.12 344.47 171.66 343.05 173.67 342.75 174.57 340.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.11 340.93 184.01 342.75 186.03 343.05 184.57 344.47 184.91 346.47 183.11 345.53 181.31 346.47 181.65 344.47 180.19 343.05 182.21 342.75 183.11 340.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.64 340.93 192.54 342.75 194.56 343.05 193.1 344.47 193.45 346.47 191.64 345.53 189.84 346.47 190.19 344.47 188.73 343.05 190.74 342.75 191.64 340.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.18 340.93 201.08 342.75 203.09 343.05 201.64 344.47 201.98 346.47 200.18 345.53 198.38 346.47 198.72 344.47 197.26 343.05 199.28 342.75 200.18 340.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.71 340.93 209.61 342.75 211.63 343.05 210.17 344.47 210.51 346.47 208.71 345.53 206.91 346.47 207.25 344.47 205.79 343.05 207.81 342.75 208.71 340.93",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.81,293.84c0,.14-11.14.26-24.88.26S173,294,173,293.84s11.14-.26,24.89-.26S222.81,293.69,222.81,293.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.67,299.7a103.91,103.91,0,0,1-10.5.26,104,104,0,0,1-10.51-.26c0-.14,4.7-.26,10.51-.26S193.67,299.56,193.67,299.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.85,307.57c0,.14-11.46.26-25.59.26s-25.6-.12-25.6-.26,11.46-.26,25.6-.26S223.85,307.43,223.85,307.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.52,295.64a6.24,6.24,0,1,0-11.63,3.15h0l0,0c.24.41.54.7.84,1.12l3.62,4.8a1.12,1.12,0,0,0,1.8,0l3.57-4.72a13.13,13.13,0,0,0,.9-1.2l0,0h0A6.16,6.16,0,0,0,162.52,295.64Zm-6.25,2.71a2.75,2.75,0,1,1,2.75-2.74A2.74,2.74,0,0,1,156.27,298.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.57 283.4 175.48 285.23 177.49 285.52 176.03 286.94 176.38 288.95 174.57 288 172.77 288.95 173.12 286.94 171.66 285.52 173.67 285.23 174.57 283.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.11 283.4 184.01 285.23 186.03 285.52 184.57 286.94 184.91 288.95 183.11 288 181.31 288.95 181.65 286.94 180.19 285.52 182.21 285.23 183.11 283.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.64 283.4 192.54 285.23 194.56 285.52 193.1 286.94 193.45 288.95 191.64 288 189.84 288.95 190.19 286.94 188.73 285.52 190.74 285.23 191.64 283.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.18 283.4 201.08 285.23 203.09 285.52 201.64 286.94 201.98 288.95 200.18 288 198.38 288.95 198.72 286.94 197.26 285.52 199.28 285.23 200.18 283.4",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.71 283.4 209.61 285.23 211.63 285.52 210.17 286.94 210.51 288.95 208.71 288 206.91 288.95 207.25 286.94 205.79 285.52 207.81 285.23 208.71 283.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.56,265.49H137.12v-63H327.56Zm-189.44-1H326.56v-61H138.12Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.46,418.24v-1l2,0a15.89,15.89,0,0,0-.09-3.43c-.14-.24-1-.36-1.57-.44a5.11,5.11,0,0,1-1.44-.32c-.42-.19-2.22-.81-4.8-1.66a4,4,0,0,0-1.29-.2l-4.12,0a4.13,4.13,0,0,0-2.13.6l-2.88,2s-2.69.59-4.15,1.07c-1.06.35-1.12,2.56-1.06,3.31l-1,.09c0-.38-.25-3.7,1.75-4.35,1.36-.45,3.64-1,4.15-1.08l2.65-1.85a5.14,5.14,0,0,1,2.66-.76l4.12,0a6.23,6.23,0,0,1,1.62.25c1.56.51,4.26,1.41,4.9,1.71a5.12,5.12,0,0,0,1.16.23c.94.13,1.92.26,2.31.94s.26,3,.18,4.44l0,.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.51,420.41a2.55,2.55,0,1,1,2.55-2.55A2.56,2.56,0,0,1,179.51,420.41Zm0-4.1a1.55,1.55,0,1,0,1.55,1.55A1.55,1.55,0,0,0,179.51,416.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.94,420.41a2.55,2.55,0,1,1,2.55-2.55A2.56,2.56,0,0,1,163.94,420.41Zm0-4.1a1.55,1.55,0,1,0,1.55,1.55A1.55,1.55,0,0,0,163.94,416.31Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.14,
    y: 417.3,
    width: 9.23,
    height: 1,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.47,419.8A9.13,9.13,0,0,1,71.25,424a16,16,0,0,1,2.2,6.93c.51,4.7-1,9.92-3,14.21-4.62-2.5-6.83-8.18-7.77-11.13-1.49-4.66-1.35-14,2.82-14.19",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.61,451.68a7.78,7.78,0,0,1,.83-7.76,10.34,10.34,0,0,1,6.9-4,4.37,4.37,0,0,1,3.59.73,3.35,3.35,0,0,1,.79,3.28,6.77,6.77,0,0,1-1.9,2.94c-2.87,2.85-6.17,5.09-10.21,4.8",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.82,466.85a4.69,4.69,0,0,1-.08-1c0-.69-.06-1.58-.1-2.65a27.33,27.33,0,0,1,.8-8.73A16.64,16.64,0,0,1,79.88,447,11.08,11.08,0,0,1,82,445.4a6.68,6.68,0,0,1,.65-.33q.22-.1.24-.09a15.47,15.47,0,0,0-7.14,9.62,29.43,29.43,0,0,0-.89,8.63c0,1.12,0,2,0,2.65A6,6,0,0,1,74.82,466.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,426.92a1.69,1.69,0,0,1,.14.4c.08.3.19.69.33,1.16.29,1,.68,2.49,1.16,4.32.94,3.64,2.18,8.7,3.42,14.32s2.24,10.72,2.91,14.43c.34,1.85.6,3.35.77,4.39l.19,1.2a3.26,3.26,0,0,1,0,.43,2.13,2.13,0,0,1-.11-.41c-.07-.31-.15-.7-.25-1.19-.22-1.08-.51-2.56-.87-4.38-.74-3.69-1.78-8.79-3-14.4s-2.43-10.68-3.32-14.34c-.43-1.8-.79-3.27-1-4.33l-.27-1.18A2,2,0,0,1,66,426.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.55,456A18.15,18.15,0,0,0,58,445.16c-1.43-.32-3.21-.35-4.05.85s-.22,2.87.6,4.09a15.53,15.53,0,0,0,16,6.27",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.55,449.37a5,5,0,0,1,.9.17,10.19,10.19,0,0,1,1,.29c.39.14.86.26,1.34.47s1,.42,1.58.72a16.28,16.28,0,0,1,1.73,1,18.88,18.88,0,0,1,6.23,6.54,18.22,18.22,0,0,1,.87,1.79,13.78,13.78,0,0,1,.61,1.62,12.8,12.8,0,0,1,.38,1.38,7.86,7.86,0,0,1,.2,1.05,3.88,3.88,0,0,1,.1.91c-.07,0-.23-1.29-.91-3.26a13.91,13.91,0,0,0-.64-1.59,16.93,16.93,0,0,0-.89-1.74,20.6,20.6,0,0,0-2.68-3.58A22,22,0,0,0,66,452.26a18,18,0,0,0-1.69-1,14.2,14.2,0,0,0-1.54-.74C60.82,449.71,59.53,449.44,59.55,449.37Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.66,191.6a8.34,8.34,0,0,0-2.45-1.46c-1.63-.76-4.38-2.42-4.53-4.21a36.88,36.88,0,0,1-.27-5c.16-3.74-4.81-5.78-5.55-9.45-.62-3.05,2-5.92,1.86-9s-2.79-5.42-4-8.27c-2.86-6.61.92-12.75-1.58-21.15a19.18,19.18,0,0,0-4.5-8.1c-1.35-1.38-5.33-4.13-9.18-4.13l-.25-.41c-2.51-3.83-8.2-4-12.48-2.35s-8,4.58-12.48,5.68c-2.16.53-1.85-2.67-4-2.23-2.86.59-6.38,3.94-7.2,6.72-.88,3-1.48,6.27-2.54,9.19-1.17,3.23-4.63,5.48-5,8.9-.37,4,3.75,7.24,3.76,11.24,0,4.31-4.76,8.16-3.24,12.2.87,2.3,3.53,3.54,4.45,5.82,1.28,3.15-1.26,6.61-1,10s3.05,5.88,5.72,7.92A120.28,120.28,0,0,0,378.81,212c5.25,1.8,10.79,3.18,16.33,2.68s11.1-3.15,14-7.9C411.53,202.88,413.37,194.26,409.66,191.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.47,141a17.24,17.24,0,0,1,16.92-18.18,17.76,17.76,0,0,1,18,16.23c.71,8,1.24,16.13,1,19-.68,8.79-6.14,11.87-8.33,12.76a12,12,0,0,1-2.39.42h0a.07.07,0,0,0-.06.07L378,181.52c.47,6.67-3.67,12.33-10.45,12.86s-11.76-4.89-12.36-11.58Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.18,146.43a1.41,1.41,0,0,1-1.26,1.51,1.37,1.37,0,0,1-1.57-1.14,1.41,1.41,0,0,1,1.25-1.52A1.38,1.38,0,0,1,383.18,146.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.17,141.26c-.16.2-1.31-.5-2.84-.38s-2.58,1-2.76.79.06-.42.52-.81a4,4,0,0,1,2.2-.85,3.78,3.78,0,0,1,2.27.53C384.06,140.85,384.25,141.17,384.17,141.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.18,147.25a1.4,1.4,0,0,1-1.25,1.51,1.37,1.37,0,0,1-1.57-1.14,1.4,1.4,0,0,1,1.25-1.52A1.37,1.37,0,0,1,369.18,147.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.15,142.71c-.16.2-1.3-.5-2.83-.38s-2.59,1-2.77.79.06-.42.52-.8a4,4,0,0,1,2.2-.86,3.8,3.8,0,0,1,2.28.53C369.05,142.31,369.23,142.62,369.15,142.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.63,153.42a10.52,10.52,0,0,1,2.45-.63c.39-.07.75-.18.79-.44a1.89,1.89,0,0,0-.35-1.12l-1.4-2.83c-1.95-4-3.39-7.37-3.23-7.44s1.88,3.13,3.83,7.17l1.35,2.85a2.17,2.17,0,0,1,.33,1.49,1,1,0,0,1-.59.61,2.3,2.3,0,0,1-.66.14A9.49,9.49,0,0,1,375.63,153.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.61,171.24s-5.86.94-13.61-2.85c.46.23,2.7,8.87,14,5.6Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.29,157.09a2.83,2.83,0,0,0-2.56-.81,2.52,2.52,0,0,0-1.66,1.05,1.54,1.54,0,0,0,0,1.8,1.85,1.85,0,0,0,2,.34,5.71,5.71,0,0,0,1.86-1.29,1.8,1.8,0,0,0,.4-.48.49.49,0,0,0,0-.56",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.22,154.81c.24,0,.38,1.6,1.9,2.65s3.27.73,3.3.95-.37.35-1.11.43a4.24,4.24,0,0,1-2.75-.71,3.52,3.52,0,0,1-1.49-2.22C371,155.23,371.1,154.81,371.22,154.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.1,137.85c-.11.42-1.66.34-3.43.69s-3.19,1-3.46.6c-.12-.16.1-.57.65-1a5.86,5.86,0,0,1,2.51-1.09,5.92,5.92,0,0,1,2.74.1C368.79,137.35,369.15,137.65,369.1,137.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.38,137.32c-.24.36-1.32.09-2.59.17s-2.32.41-2.6.07c-.12-.16,0-.52.46-.88a3.62,3.62,0,0,1,2.06-.72,3.71,3.71,0,0,1,2.13.52C383.31,136.8,383.49,137.14,383.38,137.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.17,146.09c-.16-.05-6.14-1.4-5.57,4.58s6.46,4.18,6.45,4S353.17,146.09,353.17,146.09Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,152.59s-.1.08-.27.18a1.11,1.11,0,0,1-.78.09,2.61,2.61,0,0,1-1.41-2.2,3.42,3.42,0,0,1,.15-1.52,1.22,1.22,0,0,1,.71-.88.54.54,0,0,1,.64.23c.1.16.07.28.1.29s.12-.11.05-.36a.71.71,0,0,0-.27-.35.83.83,0,0,0-.59-.1,1.46,1.46,0,0,0-1,1,3.57,3.57,0,0,0-.21,1.71,2.74,2.74,0,0,0,1.77,2.44,1.12,1.12,0,0,0,.94-.25C352,152.73,352,152.6,352,152.59Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.1,122.32A13.88,13.88,0,0,0,356.75,116c-1.41,1.42-2.52,3.16-4.18,4.27a21.31,21.31,0,0,1-5,2.55c-2.1.83-5.18,5.84-5.11,8.1l-1.05,9.89c.08,2.31,3.06,3.62,5.25,2.86s3.65-2.8,4.8-4.81,2.25-4.18,4.15-5.51c3.14-2.21,7.4-1.45,11.17-.68s8.12,1.32,11.06-1.16C380.36,129.33,380.91,125.53,380.1,122.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.44,177.05a2.07,2.07,0,0,1-.35-.46,4.8,4.8,0,0,1-.61-1.55,10.8,10.8,0,0,1,.87-6,31.67,31.67,0,0,0,1.33-3.93,7.91,7.91,0,0,0-.21-4.6,46.13,46.13,0,0,1-1.72-5,19.52,19.52,0,0,1-.26-5.73c.31-3.91,1.09-7.57.77-10.91a13.32,13.32,0,0,0-3.41-8,14,14,0,0,0-4.79-3.52c-1.29-.57-2.07-.73-2.06-.79a3.43,3.43,0,0,1,.57.1,11,11,0,0,1,1.57.5,13.7,13.7,0,0,1,5,3.46,13.41,13.41,0,0,1,3.62,8.18c.35,3.43-.43,7.14-.73,11a19.21,19.21,0,0,0,.24,5.59,45.65,45.65,0,0,0,1.68,5,8.37,8.37,0,0,1,.17,4.84,31.17,31.17,0,0,1-1.41,4,11.05,11.05,0,0,0-1,5.82A7,7,0,0,0,391.44,177.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.23,440.1l-.92,17s17.6,6.27,17.75,9.42l-34.24.08.31-26.46Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M400.23,440.1l-.92,17s17.6,6.27,17.75,9.42l-34.24.08.31-26.46Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M388.75,455.66a1.38,1.38,0,0,0-1,1.54,1.32,1.32,0,0,0,1.56.93,1.43,1.43,0,0,0,1-1.63,1.39,1.39,0,0,0-1.73-.8",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.82,466.56l0-2.67,32.89.92s1.51.63,1.32,1.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.87,456.89c0,.16-.85.24-1.68.76s-1.28,1.19-1.43,1.13.11-1,1.13-1.6S399.91,456.75,399.87,456.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.43,458.31c0,.16-.69.43-1.27,1.12s-.76,1.4-.92,1.39-.26-.92.48-1.75S403.43,458.16,403.43,458.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.4,462.44c-.15,0-.37-.77.08-1.65s1.23-1.23,1.3-1.1-.43.61-.78,1.34S405.57,462.43,405.4,462.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.63,453c-.07.15-.83-.07-1.78,0s-1.69.36-1.77.22.63-.71,1.75-.77S399.72,452.89,399.63,453Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "400.05 443.46 399.89 446.48 383.06 446.38 383.09 442.89 400.05 443.46"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M399.75,449.59a3.27,3.27,0,0,1-1.71,0,7.83,7.83,0,0,1-1.79-.53,7.45,7.45,0,0,1-1-.5,2.1,2.1,0,0,1-.51-.39.67.67,0,0,1-.07-.85.93.93,0,0,1,.74-.37,2.32,2.32,0,0,1,.64.08,6.71,6.71,0,0,1,1.07.35,6.18,6.18,0,0,1,1.56,1c.78.7,1,1.3,1,1.33s-.45-.45-1.25-1a6.64,6.64,0,0,0-1.51-.82,6.18,6.18,0,0,0-1-.29c-.36-.09-.67-.1-.77.06s0,.08,0,.18a1.49,1.49,0,0,0,.37.29,8,8,0,0,0,.9.49,8.92,8.92,0,0,0,1.65.61A11.16,11.16,0,0,1,399.75,449.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.53,449.82c-.06,0-.38-.55-.42-1.59a5.17,5.17,0,0,1,.26-1.81,5,5,0,0,1,.46-1,1.43,1.43,0,0,1,1.1-.84.8.8,0,0,1,.71.46,2.36,2.36,0,0,1,.17.61,3.74,3.74,0,0,1,0,1.11,3.82,3.82,0,0,1-.76,1.7c-.69.86-1.39,1.05-1.4,1s.53-.39,1.06-1.22a3.74,3.74,0,0,0,.57-1.55,3,3,0,0,0,0-.95c0-.35-.17-.63-.31-.6s-.47.27-.61.55a4.9,4.9,0,0,0-.44.89,5.6,5.6,0,0,0-.36,1.65C399.45,449.19,399.62,449.8,399.53,449.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.07,437.5l1.83,23,6.82,18a2.27,2.27,0,0,1-1.57,3h0A2.51,2.51,0,0,1,396,481c-3.94-3.13-18.36-14.71-18.4-16.4,0-1.95-3.58-24.18-3.58-24.18Z",
    style: {
      fill: "#1F2937"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.15,481.48l-20.74-18.42.1,1a3.65,3.65,0,0,0,1.1,2.24c1.67,1.61,6.38,6,17.28,14.73a2.54,2.54,0,0,0,2.26.47Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.47,455.35a1.43,1.43,0,0,1,.59,1.83,1.39,1.39,0,0,1-1.84.52,1.5,1.5,0,0,1-.61-1.94,1.46,1.46,0,0,1,2-.34",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M391.73,471.79c.14.06.55-1.18,1.88-1.92a7.69,7.69,0,0,1,2.66-.68c0-.06-.3-.21-.86-.25a3.75,3.75,0,0,0-2.07.49A3.53,3.53,0,0,0,391.9,471C391.68,471.44,391.67,471.78,391.73,471.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.73,474.76c.12.09.8-.7,2-1.12a17.43,17.43,0,0,1,2.27-.44,2.78,2.78,0,0,0-2.47,0C394.17,473.65,393.6,474.7,393.73,474.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.21,468.05a12.15,12.15,0,0,1,6.34-2.95,5.43,5.43,0,0,0-3.65.56A5,5,0,0,0,388.21,468.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.06,461.09c.07.13,1.32-.48,3-.65s3.07.14,3.1,0a4.82,4.82,0,0,0-3.17-.5A4.52,4.52,0,0,0,387.06,461.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.34,454.35a12.14,12.14,0,0,1,3.11-.76,13.12,13.12,0,0,1,3.2.56s-.25-.32-.83-.59a5.41,5.41,0,0,0-2.4-.47,5.06,5.06,0,0,0-2.33.62C386.55,454,386.3,454.3,386.34,454.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.28,452.31a1.94,1.94,0,0,0-.06-.87,6.24,6.24,0,0,0-.94-2.23A2.87,2.87,0,0,0,387,448a1,1,0,0,0-1.07.28,1.5,1.5,0,0,0-.26,1.06,3.53,3.53,0,0,0,3.3,2.88,3.78,3.78,0,0,0,3.67-2.26,1.27,1.27,0,0,0-.05-1.12,1,1,0,0,0-1-.43,3.26,3.26,0,0,0-1.47.89,6.27,6.27,0,0,0-1.42,1.89,1.82,1.82,0,0,0-.28.81,10.56,10.56,0,0,1,1.95-2.43,2.93,2.93,0,0,1,1.3-.74.52.52,0,0,1,.57.23.88.88,0,0,1,0,.73,3.41,3.41,0,0,1-3.21,1.93,3.08,3.08,0,0,1-2.84-2.41,1.08,1.08,0,0,1,.16-.75.52.52,0,0,1,.58-.16,2.54,2.54,0,0,1,1.13,1A9.19,9.19,0,0,1,389.28,452.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.2,255.51s10.65,19.43,10.47,40.5-21.21,151-21.21,151l-25.26-6.89c-.63,4.18,9.62-42.62,13.47-65.19,3.79-22.22-7.93-103.36-7.93-103.36l28.5-16.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.74,264.68s-8.5,21.13-5.67,37.58,24,151.89,24,151.89l24.79-4.84L385.31,273.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.23,294.3a1.69,1.69,0,0,1,0,.39c0,.28.06.66.11,1.15.08,1,.2,2.53.35,4.43.31,3.84.69,9.41,1.12,16.3.87,13.77,1.84,32.8,2.44,53.85s.7,40.11.61,53.91c0,6.9-.11,12.48-.19,16.33-.05,1.91-.08,3.4-.11,4.45,0,.48,0,.86,0,1.15a1.93,1.93,0,0,1,0,.39,1.65,1.65,0,0,1,0-.39c0-.29,0-.67,0-1.16v-4.44c0-3.88,0-9.46,0-16.33,0-13.8-.17-32.85-.76-53.9s-1.51-40.07-2.28-53.84c-.41-6.86-.73-12.43-1-16.31-.11-1.9-.2-3.39-.26-4.43,0-.49,0-.87,0-1.16A1.91,1.91,0,0,1,391.23,294.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.7,177.64s-11.94,4.93-15,6.92,10.58,44.75,10.58,44.75,6.53,17.63,4.44,25.35c-1.18,4.34-3.22,8.94-4.17,13a7.74,7.74,0,0,0,5.67,9.31c7.35,1.81,21.54,4.22,33.91.06a86.68,86.68,0,0,0,21-10.09,7.74,7.74,0,0,0,2.42-10.13,21.1,21.1,0,0,0-3-4.18c-4-4.27-7-20.48-7.81-24.94a7.44,7.44,0,0,1-.06-2.21c.48-4.19,2-19.55-.26-27.1-1.83-6-5.79-13.27-8.1-17.21a7.77,7.77,0,0,0-5-3.63l-12.23-2.68a11.44,11.44,0,0,0-3.19.18l-18.36,2.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M355.37,253.06l-2.51,7.29s15.6-4.61,20.79-10.27,10.26-9.83,12.58-10,12.26.21,13.95,1.67,7.44,5.42,7.44,5.42l-2.42-7.86-6.41-5.44-19.61-2.79Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M339.69,184.56s-5.14,3.38-5.48,12.36c0,0-.14,2.87-.24,7.24-.26,12.17-.58,36,.23,41.89,1.47,10.63,9.94,12.22,14.39,12.39s29-18.29,29-18.29l-6.9-11.28-17.54,3.87s-.07-17,.14-22.73S339.69,184.56,339.69,184.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.49,177.86s11,3,15,12.81c3.56,8.59,26.42,47.42,13.61,53.93-9.25,4.7-20.37-7.36-20.37-7.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.05,201.17a20.45,20.45,0,0,1-5.51,2,20.24,20.24,0,0,1-5.8.84c0-.15,2.56-.56,5.67-1.35S410,201,410.05,201.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.29,210.17a17.57,17.57,0,0,1-5.34,1.69,17.26,17.26,0,0,1-5.58.41c0-.15,2.48-.34,5.48-.92S414.24,210,414.29,210.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.11,220.26a25.47,25.47,0,0,0,.66-4.3,16.64,16.64,0,0,0-2.86-9.86,17.3,17.3,0,0,0-2.58-2.91,8.87,8.87,0,0,1-2.22-2.8l0-.06v-.05c.36-2.15.67-4,.9-5.37a14,14,0,0,1,.42-2,12.39,12.39,0,0,1-.19,2.06c-.19,1.4-.44,3.23-.73,5.39v-.11c.85,1.93,3.3,3.24,4.81,5.61A16.32,16.32,0,0,1,403.1,216a15.7,15.7,0,0,1-.56,3.18A5.88,5.88,0,0,1,402.11,220.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.7,226.16a15.14,15.14,0,0,1-.84-5.5,10.17,10.17,0,0,0-.28-3.35,2.59,2.59,0,0,0-2.6-1.89l-.7,8.24Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.67,207.38l-2.49,29.12-14.07.82.78-28.6a1.51,1.51,0,0,1,1.33-1.46L401,205.75A1.51,1.51,0,0,1,402.67,207.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.85,216.64a4.47,4.47,0,0,0,.11-.86c.05-.61.12-1.4.2-2.35s.15-2.2.25-3.5a3.3,3.3,0,0,1,0-.47,1,1,0,0,1,.21-.39.87.87,0,0,1,.37-.25,3,3,0,0,1,.49-.08l2.21-.27c3-.38,5.75-.74,7.73-1l2.33-.34a4.52,4.52,0,0,0,.86-.16,5.12,5.12,0,0,0-.87.05l-2.35.25c-2,.22-4.72.54-7.74.92l-2.2.28a3,3,0,0,0-.56.1,1.18,1.18,0,0,0-.48.33,1.3,1.3,0,0,0-.27.52,3.2,3.2,0,0,0,0,.52c-.07,1.3-.14,2.48-.19,3.49s-.08,1.76-.1,2.37A4.76,4.76,0,0,0,387.85,216.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.57,209.55a.7.7,0,0,1,1.35,0,.8.8,0,0,1-.3.76.71.71,0,0,1-.8,0A.66.66,0,0,1,394.57,209.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,218.08c.34,0,8.18,3,8.18,3l4.35,3.61a7.91,7.91,0,0,1,1,6c-.69,3.81-2.38,5.32-6.5,6.88l-8.18-.31-4.46-2.84a2.57,2.57,0,0,1-1.13-2.63l0-.17-.56-.72a1.41,1.41,0,0,1-.11-1.55h0a1.41,1.41,0,0,1,1.91-.53l5,2.8,3.19,0,.35-1.08-4.9-1.85-6.41-3.84a1.73,1.73,0,0,1-.56-2.44h0a1.75,1.75,0,0,1,2.15-.64l5.83,2.56,6,1.83L400,224l-7.29-4.15S391.86,217.54,396,218.08Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.81,214.27s-1.64-.7-4.08.67-5.5,3.35-5.5,3.35l-4.73,2,.43-1.28s4.9-.09,4.25-3.58l-2.91.47-2.65-1-4.36,5.38-1.33,6.1-2.75,2.91,5.43,9.14,7.88-2.67,7-.42,3.18-3.26,0-3.66,3-3.92s.23-1.81-1.38-1.79-5,4.28-5,4.28l-3.82.55s-.73-.53-.24-.93,11.13-7.3,11.48-8.61.77-2.18-.39-2.39a6.32,6.32,0,0,0-3,.65S395.69,214.44,394.81,214.27Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.31,222.32c0,.06,2.17-1.26,4.75-2.95s4.63-3.13,4.59-3.19a52.32,52.32,0,0,0-4.75,2.94A53.72,53.72,0,0,0,386.31,222.32Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.11,231.6a2.59,2.59,0,0,0,.6.12c.39.05,1,.12,1.65.16a10.79,10.79,0,0,0,2.47-.12,7.21,7.21,0,0,0,2.8-1.15,12.74,12.74,0,0,0,3.63-4.08c.36-.6.63-1.1.81-1.45a3.14,3.14,0,0,0,.26-.55s-.49.72-1.24,1.88a13.78,13.78,0,0,1-3.62,4,7.25,7.25,0,0,1-2.69,1.13,11.18,11.18,0,0,1-2.41.18C386,231.64,385.12,231.55,385.11,231.6Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.18,229.3l.19-.18.54-.55,2.06-2.14h0v0c.36-1.59.82-3.64,1.37-6.09l0,0L379.7,215l-.12,0,2.65,1h.06l2.9-.47-.13-.1a2.74,2.74,0,0,1-.11,1.45,2.5,2.5,0,0,1-1,1.13,6.38,6.38,0,0,1-3.06.85h-.09l0,.09c-.14.39-.29.83-.44,1.28l-.09.27.27-.11,4.74-2h0c1.42-.92,2.9-1.84,4.44-2.74a11.34,11.34,0,0,1,2.39-1.19,4.42,4.42,0,0,1,2.62-.08h0c.28.05.43.37.48.73a4.06,4.06,0,0,1,0,1.1l0,.27.24-.11a8.27,8.27,0,0,1,1.61-.55,2.54,2.54,0,0,1,1.64,0c.23.11.28.36.25.64a4.67,4.67,0,0,1-.19.85,2.57,2.57,0,0,1-.29.8,4.59,4.59,0,0,1-.61.64,69.57,69.57,0,0,1-5.82,4.37l-2.93,2-1.44,1-.36.25a.78.78,0,0,0-.34.39.61.61,0,0,0,.11.52,1.52,1.52,0,0,0,.33.34l.05,0h.06l3.81-.56h.06l0,0a24.57,24.57,0,0,1,3.27-3.4c.6-.45,1.26-1,1.95-.79a1,1,0,0,1,.75.59,2.06,2.06,0,0,1,.15,1l0-.06-3,3.92,0,0v0c0,1.26,0,2.48.05,3.66l0-.08-3.17,3.26.07,0-7,.46h0l-5.82,2-1.52.53-.38.15-.13.05.13,0,.4-.13,1.53-.49,5.84-1.95h0l7-.4h0l0,0,3.18-3.26,0,0v0c0-1.17,0-2.39,0-3.65l0,.07,3-3.91,0,0v0a2.45,2.45,0,0,0-.17-1.16,1.32,1.32,0,0,0-.37-.48,1.24,1.24,0,0,0-.57-.26,1.8,1.8,0,0,0-1.18.19,6,6,0,0,0-1,.65,23.56,23.56,0,0,0-3.32,3.44l.09,0-3.82.55.1,0c-.19-.14-.39-.39-.34-.55s.37-.32.59-.48l1.44-1,2.93-2a69.84,69.84,0,0,0,5.86-4.39,5.25,5.25,0,0,0,.65-.68,1.12,1.12,0,0,0,.21-.46l.12-.44a5,5,0,0,0,.21-.91,1.3,1.3,0,0,0-.05-.51.74.74,0,0,0-.36-.4,2.78,2.78,0,0,0-1.84-.08,7.85,7.85,0,0,0-1.67.58l.21.15a4.39,4.39,0,0,0,0-1.2,1.52,1.52,0,0,0-.19-.58.82.82,0,0,0-.52-.39h0a4.59,4.59,0,0,0-2.82.08,11.89,11.89,0,0,0-2.45,1.21c-1.54.91-3,1.84-4.44,2.76h0l-4.73,2,.17.16.43-1.28-.12.09a6.56,6.56,0,0,0,3.19-.9,2.77,2.77,0,0,0,1.05-1.25,2.85,2.85,0,0,0,.12-1.58v-.12l-.12,0-2.9.48h.05l-2.66-1-.07,0-.05.06-4.33,5.4v0h0c-.52,2.46-1,4.52-1.3,6.11v0c-.87,1-1.55,1.68-2,2.18l-.52.57Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.37,232.33a14.13,14.13,0,0,1-1.81,0,9.91,9.91,0,0,0-7.34,3.89c-.66.88-.94,1.52-1,1.48a3.68,3.68,0,0,1,.71-1.7,9,9,0,0,1,7.66-4.06A3.87,3.87,0,0,1,355.37,232.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.77,209.57a111.32,111.32,0,0,1,0,11.29c-.14,6.23-.37,11.27-.52,11.27a111.24,111.24,0,0,1,0-11.29C353.39,214.61,353.62,209.57,353.77,209.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334,199.3a1.8,1.8,0,0,1,0,.34c0,.25,0,.58,0,1,0,.91,0,2.19-.07,3.82,0,3.36-.11,8.16-.19,14.07s-.08,13,.12,20.85c0,1,.07,2,.1,3l.06,1.52c0,.5.09,1,.14,1.5a19.79,19.79,0,0,0,.56,3,15.94,15.94,0,0,0,1.19,2.87,12.57,12.57,0,0,0,4.3,4.61A14.61,14.61,0,0,0,346.4,258l.39,0h0a9.54,9.54,0,0,0,4.77-.73,34.71,34.71,0,0,0,4.36-2.17q4.21-2.4,8-4.94A129.7,129.7,0,0,0,377.42,240l0,.29L370.52,229l.19.08c-4.83,1-8.65,1.9-11.28,2.46l-3,.64-.78.15-.27,0,.26-.08.77-.2,3-.73c2.62-.61,6.42-1.57,11.25-2.62l.12,0,.07.11c2,3.24,4.32,7,6.94,11.25l.1.16-.15.13a126.58,126.58,0,0,1-13.45,10.36c-2.54,1.7-5.23,3.37-8,5a33.88,33.88,0,0,1-4.43,2.21,10,10,0,0,1-5.05.76h0l-.42,0a15.05,15.05,0,0,1-6.4-2.25,13,13,0,0,1-4.48-4.81,16,16,0,0,1-1.23-3,20,20,0,0,1-.57-3.11l-.15-1.54c0-.51,0-1,0-1.52,0-1-.06-2-.08-3-.18-7.86-.1-14.94,0-20.88s.24-10.75.37-14.07c.07-1.63.13-2.91.17-3.82,0-.41.05-.74.07-1A1.73,1.73,0,0,1,334,199.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.11,245.66a2.16,2.16,0,0,1-.75.06,11.25,11.25,0,0,1-2-.15,17.27,17.27,0,0,1-2.95-.71,20,20,0,0,1-3.37-1.55,29.1,29.1,0,0,1-5.36-4,11.15,11.15,0,0,1-1.89-2A17.44,17.44,0,0,1,400.9,239a38.84,38.84,0,0,0,5.37,3.86,23.79,23.79,0,0,0,3.27,1.54,20.56,20.56,0,0,0,2.85.81C414.05,245.52,415.11,245.56,415.11,245.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.45,227.42a25.92,25.92,0,0,0-4.94-2.34c-2.9-.87-5.41-.53-5.42-.71a11.16,11.16,0,0,1,10.36,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.11,222.52c0,.16-1.5.09-3.23.51s-3,1.14-3.12,1a7.08,7.08,0,0,1,6.35-1.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M353.07,231.84a6.77,6.77,0,0,0-9.36,1.29,3.35,3.35,0,0,0-.8,1.85,1.71,1.71,0,0,0,1,1.66,2.65,2.65,0,0,0,2.6-.92,12.62,12.62,0,0,1,6.81-3.59"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M408.07,224.39c2.84-.29,5.56,1.09,8.37,1.59a2,2,0,0,0,1.5-.16,1.29,1.29,0,0,0,.49-1.07,2,2,0,0,0-.45-1.12,4.6,4.6,0,0,0-3.45-1.38,14.24,14.24,0,0,0-3.9.33,4.09,4.09,0,0,0-2.75,1.61"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M354.2,181.88l-.62-7.69a39.23,39.23,0,0,0,13.25,2,31,31,0,0,0,11.24-2.42l2.24,10.79-6.64,10.05-5.83,2.7-10.26-1.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,200.22c-.07,0-.31-1.29-.86-3.33a19.86,19.86,0,0,0-3.51-7.35,11.16,11.16,0,0,0-6.86-4,11.44,11.44,0,0,0-3.38.14,2.59,2.59,0,0,1,.88-.31,7.13,7.13,0,0,1,2.54-.15,11.06,11.06,0,0,1,7.19,4.06,18.87,18.87,0,0,1,3.46,7.57c.24,1,.39,1.89.47,2.48A3.43,3.43,0,0,1,355,200.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.07,173.75a3,3,0,0,1,.27.9,7,7,0,0,1,.15,1.1,2.28,2.28,0,0,1-.38,1.46A7.19,7.19,0,0,1,377,178.6a7.11,7.11,0,0,1-1.75,1.09,21.78,21.78,0,0,1-4.46,1.36,23.55,23.55,0,0,1-8.43.12,20.74,20.74,0,0,1-2.49-.59,3.62,3.62,0,0,1-.87-.34c0-.08,1.29.33,3.41.6a25.48,25.48,0,0,0,8.29-.25A23.41,23.41,0,0,0,375,179.3a7,7,0,0,0,1.68-1,6.33,6.33,0,0,0,1.13-1.27,2,2,0,0,0,.4-1.27,10.29,10.29,0,0,0-.07-1.08A5.2,5.2,0,0,1,378.07,173.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.94,260.31a1.54,1.54,0,0,1-.35.23l-1,.6c-.46.26-1,.56-1.71.88s-1.43.72-2.3,1.08a65.74,65.74,0,0,1-6.19,2.35,71.06,71.06,0,0,1-7.85,2,69.9,69.9,0,0,1-8,1,65.63,65.63,0,0,1-6.62.09c-.94,0-1.79-.1-2.54-.16s-1.38-.12-1.91-.19l-1.2-.16-.41-.09a1.25,1.25,0,0,1,.42,0l1.21.08c.52,0,1.16.09,1.91.11s1.59.09,2.53.09c1.87,0,4.11,0,6.58-.19a70.24,70.24,0,0,0,15.8-3c2.36-.75,4.45-1.52,6.18-2.25.87-.34,1.64-.7,2.32-1s1.26-.58,1.73-.81l1.1-.52A2,2,0,0,1,403.94,260.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.74,209.22a12.73,12.73,0,0,1-3-.35,37,37,0,0,1-13.3-5.45,12.34,12.34,0,0,1-2.36-1.82,26.41,26.41,0,0,1,2.56,1.51,48.71,48.71,0,0,0,6.38,3.2,48.21,48.21,0,0,0,6.8,2.2A26.75,26.75,0,0,1,353.74,209.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,215.59a13.85,13.85,0,0,1-3,.12,47.26,47.26,0,0,1-7.29-.79A46.48,46.48,0,0,1,336.6,213a13.91,13.91,0,0,1-2.78-1.21,22.61,22.61,0,0,1,2.9.86,64,64,0,0,0,7,1.75,68.13,68.13,0,0,0,7.22.93A23,23,0,0,1,354,215.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.86,202.21a11.79,11.79,0,0,1-1.64.56c-1.07.33-2.63.78-4.55,1.32-3.85,1.08-9.19,2.49-15.12,3.93s-11.33,2.62-15.25,3.42c-1.95.4-3.54.71-4.64.9a12.28,12.28,0,0,1-1.72.26,9.94,9.94,0,0,1,1.68-.46l4.61-1.06c3.89-.9,9.27-2.13,15.2-3.57s11.27-2.79,15.14-3.78l4.59-1.16A11.09,11.09,0,0,1,396.86,202.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.68,119.37l-1-1.32a78.11,78.11,0,0,0-20.55,5.24c-2.63,1.07-5.29,2.35-7.09,4.54-2.47,3-2.86,7.19-3.15,11.08-1.07,14.83-4.82,29.44-.15,43.56,1.12-1.81,6.18-2,8.27-2.37s4.27-.54,6.16-1.51a8.36,8.36,0,0,0,4.18-5.35,10.07,10.07,0,0,0-.76-6.8c-1.13-2.35-3.15-4.62-2.66-7.18s3.6-4.22,4.32-6.85c1.25-4.55-4.72-8.71-4.07-13.38a7.48,7.48,0,0,1,3-5.37,5.59,5.59,0,0,1,4.59-1C372.52,133.47,376.35,125.14,375.68,119.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.36,181.35s.2-.28.6-.79a15.14,15.14,0,0,0,1.46-2.44,14.91,14.91,0,0,0,1.27-4.28,13.66,13.66,0,0,0-.44-5.86c-.6-2.12-1.87-4.23-2.59-6.79a7.17,7.17,0,0,1-.06-4.11,8.69,8.69,0,0,1,2.47-3.59,16.2,16.2,0,0,0,2.9-3.34,5.8,5.8,0,0,0,.38-4.38c-.4-1.51-1.11-3-1.67-4.55a9.78,9.78,0,0,1-.63-5,15.19,15.19,0,0,1,1.49-4.86,11,11,0,0,1,3.1-3.86,8.58,8.58,0,0,1,2.16-1.13,11,11,0,0,1,2.31-.57c1.55-.23,3.07-.16,4.46-.47a6.75,6.75,0,0,0,3.58-2c.93-1,1.72-2.1,2.55-3.12a13.82,13.82,0,0,1,2.69-2.71,3.43,3.43,0,0,1,1.75-.64,7.75,7.75,0,0,1,1.74.05A7.86,7.86,0,0,1,378,120a13.36,13.36,0,0,1,2.06,4,6.76,6.76,0,0,1,.3,2.85,3,3,0,0,1-.28,1s.11-.33.18-1a7,7,0,0,0-.4-2.78,13.14,13.14,0,0,0-2.1-3.94,7.52,7.52,0,0,0-4.93-2.87,4.32,4.32,0,0,0-3.21.55,13.28,13.28,0,0,0-2.58,2.65c-.82,1-1.6,2.12-2.56,3.16a7.17,7.17,0,0,1-3.8,2.13c-1.48.33-3,.26-4.5.49a9.87,9.87,0,0,0-2.2.56,7.45,7.45,0,0,0-2,1.07,10.35,10.35,0,0,0-2.95,3.67,15,15,0,0,0-1.44,4.69,9.24,9.24,0,0,0,.61,4.8c.55,1.54,1.26,3,1.67,4.6a6.3,6.3,0,0,1-.44,4.75,16.16,16.16,0,0,1-3,3.44,8.23,8.23,0,0,0-2.37,3.38,6.79,6.79,0,0,0,0,3.87c.67,2.48,1.92,4.62,2.53,6.79a14.12,14.12,0,0,1,.37,6,14.61,14.61,0,0,1-1.38,4.33,13.7,13.7,0,0,1-1.55,2.41c-.21.25-.39.43-.5.56S343.37,181.36,343.36,181.35Z",
    style: {
      fill: "#455a64"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserveRide);
export default __webpack_public_path__ + "static/media/reserve-ride.a91bb4c868ef9a91a12800d44a55c128.svg";
export { ForwardRef as ReactComponent };